<template>
	<div class="storePendingorder">
		<Dialog :openReceiveDialog.sync="openReceiveDialog" :receiveItems='receiveItems'></Dialog>
		<Table-Dia :printHistorDia.sync="printHistorDia"></Table-Dia>
		<div v-if="!hasData">
			<loading :tip="tip"></loading>
		</div>
		<div v-else>
			<div v-show="isNotify" class="notify-boxw">
				<div style="font-weight: bold; margin-bottom: 15px;">{{ $t('other.a963') }}</div>
				<span style="margin:10px 20px 0 0">{{ $t('other.a964') }}{{ multipleSelection.length }}{{ $t('other.a965')
				}}{{ successTotal - failErrorOrder.length }}</span>
				<i v-show="percentage !== 100" class="el-icon-loading"></i>
				<el-progress style="padding: 18px 0" :text-inside="true" :stroke-width="18" :percentage="percentage"
					status="success"></el-progress>
				<div v-show="failErrorOrder.length > 0 && percentage == 100"
					style="padding:0 2px 10px 2px;font-size:12px;color:red">
					{{ failErrorOrder.length }} orders failed to generate ! <span class="viewMore" @click="viewError()">view
						Detail</span>
				</div>
				<div style="text-align:right;padding:0 15px">
					<el-button size="mini" type="info" @click="isNotify = false">{{ $t('other.a5') }}</el-button>
					<el-button size="mini" type="primary" @click="ignk()">{{ $t('other.a1011') }}</el-button>
				</div>
			</div>
			<!-- 旗帜弹窗 -->
			<flag-plugin :isFlage.sync="isFlage" @setFlags="setFlags"></flag-plugin>
			<div class="top_box">
				{{ $t('storePending').desc }}
			</div>
			<div class="step">
				<el-steps finish-status="success">
					<el-step :title="storePending.fisrtStep" :description="storePending.firstDesc">{{
						$t('storePending').MassPrintShipingLabel }}</el-step>
					<el-step :title="storePending.secondStep" :description="storePending.secondDesc"></el-step>
					<el-step :title="storePending.threeStep" :description="storePending.threeDesc"></el-step>
					<el-step :title="storePending.fourStep" :description="storePending.fourDesc"></el-step>
				</el-steps>
			</div>

			<el-dialog title="系统提示" :visible.sync="systemDia" :close-on-click-modal='false' width="30%">
				<div style="display:flex">
					<i class="iconfont icon-jinggao1"></i>
					<span style="font-size:20px;">{{ Systemtext }}</span>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button type="info" @click="systemDia = false">{{ $t('other.a106') }}</el-button>
					<el-button type="primary" @click="printFastOrderSH(0)">{{ $t('other.a1012') }}</el-button>
					<el-button type="primary" @click="printFastOrderSH(1)">{{ $t('other.a1013') }}</el-button>
				</span>
			</el-dialog>

			<!-- <div class="title">默认地址</div> -->
			<el-dialog :title="$t('other.a1014')" :visible.sync="managementAdrress" width="80%">
				<div>
					<el-table :data="list" :key="itemKey" border style="width: 100%">
						<el-table-column :label="$t('other.a518')" prop="userId">
							<template slot-scope="props">
								{{ props.row.receiver }}
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a899')" prop="userId">
							<template slot-scope="props">
								{{ props.row.phone }}
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a517')" prop="userId">
							<template slot-scope="props">
								{{ props.row.address }}
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a626')" prop="userId">
							<template slot-scope="props">
								{{ props.row.postcode }}
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a626')" prop="userId">
							<template slot-scope="props">
								<div>
									<span :class="{ 'ioingn': !props.row.defaultFrom, 'pking': props.row.defaultFrom }"
										@click="setDefult(props.row, props.$index, 0)">{{ $t('other.a1029') }}</span>

								</div>
								<div>
									<span
										:class="{ 'ioingn': !props.row.defaultReceive, 'oegvjh': props.row.defaultReceive }"
										@click="setDefult(props.row, props.$index)">{{ $t('other.a1030') }}</span>

								</div>
							</template>
						</el-table-column>


					</el-table>
				</div>
				<div style="text-align: right;margin-top:20px">
					<el-button type="primary" @click="managementAdrress = false">{{ $t('shopaccess.cancel') }}</el-button>
					<el-button type="primary" @click="continuePrint()">{{ $t('other.a274') }}</el-button>
				</div>
			</el-dialog>
			<!-- <div class="title">待处理订单</div> -->
			<el-dialog :title="$t('homeTwo.orderPrinted')" :visible.sync="printedvisabable" width="80%">
				<el-table border :data="printedUrl" height="400">
					<el-table-column :label="$t('orderPrint.Print_name')">
						<template slot-scope="scope">
							{{ scope.row.name }}
						</template>
					</el-table-column>
					<el-table-column :label="$t('homeTwo.StoreName')" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							{{ scope.row.shopName }}
						</template>
					</el-table-column>
					<el-table-column :label="$t('homeTwo.Platformtype')" width="120">
						<template slot-scope="scope">
							{{ scope.row.platform }}
						</template>
					</el-table-column>
					<el-table-column :label="$t('unprocessedorder.printed_time')" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							{{ scope.row.createTime ? getTime(scope.row.createTime) : $t('homeTwo.Notprinted') }}
						</template>
					</el-table-column>
					<el-table-column prop="address" width="280px" :label="$t('homeTwo.operating')">
						<template slot-scope="scope">
							<el-button style="width:110px;" size="mini" :type="!scope.row.hasPrined ? 'primary' : 'warning'"
								@click="gotoprint(scope.row)">{{ scope.row.hasPrined ? $t('storePending.printed') :
									$t('unprocessedorder.print_order') }}</el-button>
							<el-button style="width:110px;" size="mini" type="primary" @click="printPicklist(scope.row)">{{
								$t('unprocessedorder.print_picking_list') }}</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div style="text-align: right;margin-top:20px">
					<el-button type="primary" @click="printedvisabable = false">{{ $t('shopaccess.cancel') }}</el-button>
					<el-button type="primary" @click="refleshPage()">{{ $t('homeTwo.hasPrint') }}</el-button>
				</div>
			</el-dialog>

			<el-dialog :title="$t('other.a1016')" :visible.sync="viewFaileDetail" width="50%">
				<el-table border :data="failErrorOrder" height="400">
					<el-table-column :label="$t('other.a60')">
						<template slot-scope="scope">
							{{ scope.row.orderId }}
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a1017')">
						<template slot-scope="scope">
							{{ scope.row.orderPdf.msg }}
						</template>
					</el-table-column>
				</el-table>
				<div style="text-align: right;margin-top:20px">
					<el-button type="primary" @click="viewFaileDetail = false">{{ $t('shopaccess.cancel') }}</el-button>

				</div>
			</el-dialog>



			<!-- 填写退回审核的理由 -->
			<el-dialog :title="$t('homeTwo.returnReason')" :visible.sync="diaReturnOrder" width="30%">
				<div>
					<!-- 历史退回审核理由：
					<el-select style="margin-bottom:12px" v-model="reasonReturn" placeholder="暂无历史退审理由">
						<el-option
						v-for="item in reasonOptions"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select> -->
					<el-input type="textarea" :rows="2" :placeholder="$t('homeTwo.returnReason')" v-model="textarea">
					</el-input>
				</div>
				<div style="text-align: right;margin-top:20px">
					<el-button type="primary" @click="diaReturnOrder = false">{{ $t('shopaccess.cancel') }}</el-button>
					<el-button type="primary" @click="returnOrderCopy()">{{ $t('homeTwo.jkf') }}</el-button>
				</div>
			</el-dialog>


			<el-dialog :title="$t('other.a1018')" :visible.sync="dialogVisible" width="30%">
				<div>
					<el-form ref="form" :model="DxsObjParams" :rules='rules' label-width="80px">
						<el-form-item :label="$t('other.a897')">
							<span>{{ DxsObjParams.msgToStore }}</span>
						</el-form-item>
						<el-form-item :label="$t('other.a1019')" prop="ruleId">
							<el-select v-model="DxsObjParams.ruleId" :placeholder="$t('other.a634')">
								<el-option v-for="item in logisticsOption" :key="item.ruleId" :label="item.logisticsName"
									:value="item.ruleId">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('other.a1020')" prop="length">
							<el-input style="width:100px;margin-right:10px" v-model="DxsObjParams.length"
								:placeholder="$t('other.a1023')"></el-input>
							<el-input style="width:100px;margin-right:10px" v-model="DxsObjParams.width"
								:placeholder="$t('other.a1024')"></el-input>
							<el-input style="width:100px;margin-right:10px" v-model="DxsObjParams.height"
								:placeholder="$t('other.a1025')"></el-input>
						</el-form-item>

						<el-form-item :label="$t('other.a632')" prop="weight">
							<el-input v-model="DxsObjParams.weight"></el-input>
						</el-form-item>

						<el-form-item :label="$t('other.a1021')">
							<el-input style="width:120px;margin-right:10px" v-model="DxsObjParams.actualCost"
								:placeholder="$t('other.a1026')"></el-input>

							<el-select style="width:150px" v-model="DxsObjParams.currency" :placeholder="$t('other.a1027')">
								<el-option v-for="item in currencyoptions" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>

						</el-form-item>
						<el-form-item :label="$t('other.a1022')">
							<el-input v-model="DxsObjParams.trackingNo" :placeholder="$t('other.a1022')"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">{{ $t('other.a106') }}</el-button>
					<el-button type="primary" @click="generateLogisticOrder()">{{ $t('other.a279') }}</el-button>
				</span>
			</el-dialog>

			<div class="btn_box">
				<div class="btn_outer" v-show="index !== 13" v-for="(item, index) in btnlist" :key="index">
					<div style="display: flex;justify-content: flex-start;">
						<!-- 类型 -->
						<div class="btn_desc">{{ item.desc }}:</div>
						<!-- 选项 -->
						<div>
							<span :class="{ 'btn_item': true, 'btn_item_active': activeIndex[index] == indexTwo }"
								v-for="(children, indexTwo) in item.option" :key="indexTwo"
								@click="handleBtn(children.key, index, indexTwo)">
								<span v-if="index !== 8"
									:class="{ 'kvhfk': index == 10 && children.key !== 'all' && children.value.length > 0 }">{{
										conversion(children.key, index) }}({{ children.value.length }})</span>
								<span
									v-if="index == 8 && (children.key == 'all' || children.key == 0 || children.key == 99999)">{{
										conversion(children.key, index) }}<span v-if="index == 8 && (children.key == 'all')">({{
		children.value.length }})</span></span>
								<el-tooltip style="font-size: 16px;" effect="light"
									v-if="index == 8 && indexTwo > 0 && children.key !== 'all' && children.key !== 0"
									:content="getDesc(children.key)" placement="top">
									<span v-if="index == 8 && indexTwo > 0 && children.key !== 'all'"
										:style="showFlageStyle(children.key)"></span>
								</el-tooltip>
								<span v-if="index == 8 && indexTwo > 0 && children.key !== 'all'">({{ children.value.length
								}})</span>
							</span>
						</div>
					</div>
				</div>
			</div>
			<div class="search_wraper">
				<div class="search_item">
					<span class="item_desc">{{ $t('homeTwo.OrderTracking') }}：</span>
					<el-input v-model="searchOrderId" :placeholder="$t('homeTwo.orderSearch')" clearable></el-input>
				</div>
				<div class="search_item">
					<span class="item_desc">{{ $t('homeTwo.Includequery') }}：</span>
					<el-input v-model="searchName" :placeholder="$t('homeTwo.orthersSearch')" clearable></el-input>
				</div>
				<div class="search_item">
					<span>{{ $t('orderPrint.Order_sorting') }}：</span>
					<el-select style="width:300px" v-model="sortType" :placeholder="$t('orderPrint.Order_sorting')"
						@change="choiceshopId()">
						<el-option :label="$t('orderPrint.Ordertimeorder01')" value="1">{{ $t('orderPrint.Ordertimeorder01')
						}}</el-option>
						<el-option :label="$t('orderPrint.Ordertimeorder02')" value="2">{{ $t('orderPrint.Ordertimeorder02')
						}}</el-option>
						<el-option :label="$t('orderPrint.Sortbyquantity01')" value="3">{{ $t('orderPrint.Sortbyquantity01')
						}}</el-option>
						<el-option :label="$t('orderPrint.Sortbyquantity02')" value="4">{{ $t('orderPrint.Sortbyquantity02')
						}}</el-option>
						<el-option :label="$t('orderPrint.Sort_by_number_ofsku01')" value="5">{{
							$t('orderPrint.Sort_by_number_ofsku01') }}</el-option>
						<el-option :label="$t('orderPrint.Sort_by_number_ofsku02')" value="6">{{
							$t('orderPrint.Sort_by_number_ofsku02') }}</el-option>
						<el-option :label="$t('orderPrint.Sort_by_pushtime_late')" value="7">{{
							$t('orderPrint.Sort_by_pushtime_late') }}</el-option>
						<el-option :label="$t('orderPrint.Sort_by_pushtime_early')" value="8">{{
							$t('orderPrint.Sort_by_pushtime_early') }}</el-option>
					</el-select>
				</div>
			</div>

			<div class="operation_area">

				<div class="opeartion_btn">
					<el-dropdown class="checkallbox">
						<span class="el-dropdown-link">
							<el-button type="primary">
								{{ $t('storePending').massArrangeShipment }}<i
									class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="startReadyOrders(0)">
								<span class="checkallbox">{{ $t('storePending').drop_off }}</span>
							</el-dropdown-item>
							<el-dropdown-item @click.native="startReadyOrders(1)">
								<span class="checkallbox">{{ $t('storePending').pick_up }}</span>
							</el-dropdown-item>

							<!-- <el-dropdown-item @click.native="systemAdmin(1)">
								<span class="checkallbox" >systemAdmin</span>
							</el-dropdown-item> -->
						</el-dropdown-menu>
					</el-dropdown>
				</div>

				<div class="opeartion_btn">
					<el-dropdown class="checkallbox">
						<span class="el-dropdown-link">
							<el-button type="primary">
								{{ $t('storePending').massprint }}<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="mergerPrintPicklist()">
								<span class="checkallbox">{{ $t('storePending').PrintPacklist }}</span>
							</el-dropdown-item>
							<el-dropdown-item @click.native="goStockList()">
								<span class="checkallbox">{{ $t('storePending').PrintPicklist }}</span>
							</el-dropdown-item>
							<el-dropdown-item @click.native="checkOrderTypePICKMerge()">
								<span class="checkallbox">{{ $t('storePending').massprint }}</span>
							</el-dropdown-item>
							<el-dropdown-item @click.native="selfBuiltOrder()">
								<span class="checkallbox">{{ $t('other.a1031') }}</span>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
				<div class="opeartion_btn">
					<el-dropdown class="checkallbox">
						<span class="el-dropdown-link">
							<el-button type="primary">
								{{ $t('storePending').MassPrintShipingLabel }}<i
									class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
						</span>
						<el-dropdown-menu slot="dropdown">
							<!-- <el-dropdown-item  @click.native="printDefaultOrderCopy()">
								<span class="checkallbox" >{{$t('other.a1036')}}</span>
							</el-dropdown-item> -->
							<el-dropdown-item @click.native="printDefaultOrder()">
								<span class="checkallbox">{{ $t('storePending').PrintShipingLabel }}</span>
							</el-dropdown-item>
							<!-- <el-dropdown-item v-show="userId !== 'TWStockYC'"  @click.native="printFastOrderCopy()" >
								<span class="checkallbox" >{{$t('storePending').PrintShipingLabel}}</span>
							</el-dropdown-item> -->
							<el-dropdown-item @click.native="printFastOrder()">
								<span class="checkallbox">{{ $t('storePending').ShipingLabel_Packlist }}</span>
							</el-dropdown-item>
							<el-dropdown-item v-show="showFastBtn" @click.native="checkOrderTypePICK()">
								<span class="checkallbox">{{ $t('orderPrint.Print_picklist') }}</span>
							</el-dropdown-item>
							<el-dropdown-item v-show="showFastBtn" @click.native="checkOrderType()">
								<span class="checkallbox">{{ $t('other.a1032') }}(Shopee)</span>
							</el-dropdown-item>
							<el-dropdown-item v-show="showFastBtn" @click.native="printFastOrderLA()">
								<span class="checkallbox">{{ $t('other.a1032') }}(LAZADA)</span>
							</el-dropdown-item>
							<el-dropdown-item v-show="showFastBtn && userArea == 'VN'" @click.native="ignkfb()">
								<span class="checkallbox">{{ $t('other.a1033') }}(Shopee&VN)</span>
							</el-dropdown-item>
							<!-- <el-dropdown-item v-show="showFastBtn " @click.native="printFastOrderLACopy()">
								<span class="checkallbox" >allenText</span>
							</el-dropdown-item> -->
							<el-dropdown-item v-show="showFastBtn" @click.native="showinformation">
								<span class="checkallbox">{{ $t('other.a1034') }}</span>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<el-dialog :title="$t('other.a971')" :visible.sync="information" width="60%"
						:before-close="handleClose">
						<el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign">
							<el-form-item :label="$t('other.a972')">
								<el-input v-model="formLabelAlign.name"></el-input>
							</el-form-item>
							<el-form-item :label="$t('other.a973')">
								<el-input v-model="formLabelAlign.phone"></el-input>
							</el-form-item>
							<el-form-item :label="$t('other.a974')">
								<el-input v-model="formLabelAlign.address" type="textarea" :rows="5"></el-input>
							</el-form-item>
						</el-form>
						<span slot="footer" class="dialog-footer">
							<el-button @click="information = false">{{ $t('other.a106') }}</el-button>
							<el-button type="primary" @click="chckeformation">{{ $t('other.a279') }}</el-button>
						</span>
					</el-dialog>
				</div>
				<div class="opeartion_btn"><el-button type="primary" @click="downloadPrint(1)">{{$t('other.a3419')}}</el-button></div>
				<div class="opeartion_btn"><el-button type="primary" @click="downloadAll()">{{$t('other.a3424')}}</el-button></div>
				<div class="opeartion_btn"><el-button type="primary" @click="diaReturnOrder = true">{{
					$t('storePending').ReturnBacktoUser }}</el-button></div>
				<!-- <div class="opeartion_btn"><el-button type="primary" @click="returnOrder()">{{$t('storePending').ReturnBacktoUser}}</el-button></div>	 -->
				<div class="opeartion_btn"><el-button type="primary" @click="SynchronizeCheck">{{
					$t('storePending').SynchronizeOrder }}</el-button></div>
				<!-- <div class="opeartion_btn">
					<el-dropdown class="checkallbox">
						<span class="el-dropdown-link">
							<el-button  type="primary">
								{{$t('storePending').SynchronizeOrder}}<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="Synchronize(0)">
								<span class="checkallbox" >{{$t('pendingorder.last_3_days')}}</span>
							</el-dropdown-item>
							<el-dropdown-item @click.native="Synchronize(1)">
								<span class="checkallbox" >{{$t('pendingorder.last_7_days')}}</span>
							</el-dropdown-item>
							<el-dropdown-item @click.native="Synchronize(2)">
								<span class="checkallbox" >{{$t('pendingorder.last_1_month')}}</span>
							</el-dropdown-item>
							<el-dropdown-item @click.native="reloadorder =true">
								<span class="checkallbox" >{{$t('homeTwo.syncSingleOrder')}}</span>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>	 -->

				<div class="opeartion_btn"><el-button type="primary" @click="showhistoryRecord()">{{ $t('other.a1035')
				}}</el-button></div>
				<div class="opeartion_btn"><el-button type="primary" @click="extportOrderInfo()">{{ $t('other.a977')
				}}</el-button></div>
				<div class="opeartion_btn"><el-button type="primary" @click="printDefaultOrderCopy()">{{ $t('other.a1036')
				}}</el-button></div>

			</div>

			<div class="checkallbox" @click="toggleSelection">{{ chooseAll ? $t('orderPrint.Unselect_current_page') :
				$t('orderPrint.Select_current_page') }}({{ multipleSelection.length }})</div>

			<!-- <div class="operation_area">
				<div class="checkallbox" @click="toggleSelection">{{chooseAll ? $t('orderPrint.Unselect_current_page') : $t('orderPrint.Select_current_page')}}({{multipleSelection.length}})</div>
			</div> -->
			<div class="order_box">
				<el-table ref="multipleTable" :data="listData" :key="tableKey" tooltip-effect="dark" border
					style="width: 100%" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55">
					</el-table-column>

					<el-table-column label="Order ID">
						<template slot-scope="scope">
							<div>
								<el-tooltip v-show="scope.row.amend" effect="light" :content="$t('other.a978')"
									placement="bottom">
									<i class="iconfont icon-sign"></i>
								</el-tooltip>
								<span>{{ scope.row.orderId }}</span>
							</div>
							<div>{{ scope.row.orderStatus }}</div>
							<div>{{ $t('homeTwo.Sellersname') }}：{{ scope.row.userId }}</div>
							<div class="ordersn-box tooldesc" @click="editMark(scope.row)">
								<i class="el-icon-edit" v-show="!scope.row.flagId && userPos == 'SELLER'">
									{{ $t('other.a979') }}</i>
								<div style="width: 100%;text-overflow: ellipsis;" v-show="scope.row.flagId > 0"
									v-for="(item, index) in showFlage(scope.row.flagColor) " :key="index">
									<span :style="item.style"></span>
									<span style="width: 80px;margin-left: 5px;text-overflow: ellipsis;">{{ scope.row.flagDes
									}}</span>
								</div>
							</div>
							<div v-if="scope.row.sensitive">
								<span class="sensitive">{{ $t('other.a785') }}</span>
							</div>
							<div v-if="scope.row.distributeGoods">
								<span class="distributeGoods">{{ $t('other.a710') }}</span>
							</div>
							<div v-if="scope.row.msgToStore" style="color:red;margin-top:15px;">
								{{ $t('other.a499') }}：{{ scope.row.msgToStore }}</div>
						</template>
					</el-table-column>
					<el-table-column label="Order Time" width="220">
						<template slot-scope="scope">
							<div class="order_time">{{ $t('lazada.time') }}：{{ scope.row.createTime }}</div>
							<!-- <div class="order_time" v-if="!scope.row.cod" >{{$t('other.a589')}}：{{scope.row.payTime}}</div>
							<div class="order_time" v-if="scope.row.cod" >{{$t('other.a589')}}：{{$t('other.a980')}}</div> -->
							<div class="order_time">{{ $t('homeTwo.Pushtime') }}：{{ scope.row.auditTime }}</div>
							<div class="order_time">{{ $t('homeTwo.printingtime') }}({{ scope.row.printNum }})：
								<span v-if="scope.row.printTime">{{ scope.row.printTime }}</span>
								<span v-if="scope.row.printTime == null">{{ $t('other.a949') }}</span>
							</div>
							<div class="order_time" v-if="scope.row.checkTime">{{ $t('homeTwo.checkTime') }}：
								<span>{{ scope.row.checkTime }}</span>
							</div>
							<div class="order_time">{{ $t('homeTwo.Deliverytime') }}：
								<span v-if="scope.row.packagedTime">{{ scope.row.packagedTime }}</span>
								<span v-if="scope.row.packagedTime == null">{{ $t('homeTwo.Notoutofstock') }}</span>
							</div>
						</template>
					</el-table-column>

					<el-table-column label="Product(s)">
						<template slot-scope="scope">
							<span v-for="(item, index) in scope.row.items" :key="index">
								<el-tooltip placement="right">
									<span slot="content">
										<div style="display: flex; color: #FFFFFF;align-items: center;">
											<span
												style="display: inline-block;width: 80px;height: 80px;margin-right: 20px;">
												<img style="width:100%"
													:src="item.attributeImage ? item.attributeImage : item.image" />
												<!-- <img style="width:100%" :src="item.storeItem ? item.storeItem.image : item.image" /> -->
											</span>
											<span>
												<!-- <div style="padding:2px 0px;font-size:15px">Product ID：{{item.itemId}} <el-button style="margin-left:10px" size="mini" type="primary" @click="CopyText(item.itemId)">Copy</el-button></div> -->
												<div style="padding:2px 0px;font-size:15px">Name：{{ item.itemName }}</div>
												<!-- <div style="padding:2px 0px;font-size:15px">Variation name：{{item.variationName}}</div>
												<div style="padding:2px 0px;font-size:15px">Parent SKU：{{item.itemSku}}<el-button v-show="item.itemSku" style="margin-left:10px" size="mini" type="primary" @click="CopyText(item.itemSku)">Copy</el-button></div>
												<div  style="margin-top: 5px;font-size:15px">SKU：{{item.variationSku}}<el-button v-show="item.variationSku" style="margin-left:10px" size="mini" type="primary" @click="CopyText(item.variationSku)">Copy</el-button></div> -->
												<div v-if="item.storeItem !== null">
													<div style="padding:5px 0px;font-size:15px">
														cusCode：{{ item.storeItem.cusCode }}（{{ item.storeItem.component ?
															$t('other.a251') : $t('other.a252') }}）</div>

													<div style="padding:5px 0px;font-size:15px">
														P_SKU：{{ item.storeItem.itemSku ? item.storeItem.itemSku :
															$t('other.a260') }}</div>
													<div style="margin-top: 5px;font-size:15px"
														v-if="item.storeItem.children !== null && !item.storeItem.component">
														<div v-for="(childre, indexTBB) in item.storeItem.children"
															:key="indexTBB">
															{{ $t('other.a920') }}({{ childre.cusCode }})：{{ childre.skuName
															}}
															{{ $t('other.a633') }}：{{ childre.rate *
																item.variationQuantityPurchased }}
														</div>
													</div>
													<div style="margin-top: 5px;font-size:15px"
														v-if="item.storeItem.children == null">
														<div>
															W_SKU：{{ item.storeItem.skuName }}
															{{ $t('other.a633') }}：{{ item.variationQuantityPurchased }}
														</div>
													</div>
													<div v-if="item.storeItem.additions !== null"
														style="padding:5px 0px;font-size:15px">
														<div style="margin-top: 5px;font-size:15px;color:red"
															v-for="(gift, giftIndex) in item.storeItem.additions"
															:key="giftIndex">
															{{ $t('other.a497') }}：{{ gift.skuName }}（{{ gift.cusCode }}）
															{{ $t('other.a567') }}：{{ gift.rate *
																item.variationQuantityPurchased }}
														</div>

													</div>
												</div>
												<div style="margin-top: 5px;font-size:15px">
													{{ $t('other.a250') }}{{ item.storeItem ? item.storeItem.storeNum :
														'' }}，{{ $t('other.a1038') }}：{{ item.storeItem ?
		item.storeItem.unShipped :
		'' }} ，{{ $t('other.a1037') }}：{{ item.storeItem ? item.storeItem.stock
		:
		'' }}</div>
											</span>
										</div>
									</span>
									<span>
										<span class="pic_wrapper">
											<img style="width: 100%;"
												:src="item.attributeImage ? item.attributeImage : item.image" />
											<span class="pic-wrapper-quantity">{{ item.variationQuantityPurchased }}</span>
											<span
												v-if="item.storeItem && item.storeItem.putAway && !item.storeItem.component"
												class="pic-wrapper-desc">{{ $t('other.a254') }}</span>
											<span v-if="item.storeItem && item.storeItem.sensitive"
												class="pic-wrapper-sensitive">{{ $t('other.a785') }}</span>
										</span>
									</span>
								</el-tooltip>


							</span>
						</template>
					</el-table-column>
					<el-table-column label="Print Photo">
						<template slot-scope="scope">
							<span v-for="(item, index) in scope.row.items" :key="index">
								<span class="pic_wrapper" v-if="item.pintImage">
									<img style="width: 100%;" :src="item.pintImage" crossOrigin="anonymous" />
								</span>
								<span class="pic_wrapper" v-if="item.standardPattern&&!item.pintImage">
									<img style="width: 100%;" :src="item.standardPattern.standardPatternPrintImagesList[0].imageUrl" crossOrigin="anonymous" />
								</span>
							</span>
							<div v-if="scope.row.items.find(item=>item.pintImage||item.standardPattern)">
								<el-button type="primary" @click="downloadPrint(2,scope.row.items,scope.row)" size="mini">{{$t('other.a3418')}}</el-button>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="Logistics">
						<template slot-scope="scope">
							<div class="ordersn-box" v-show="justStoreTypeCopy(scope.row.storeId)"><el-button type="primary"
									size="mini" @click="inputOrderInfo(scope.row)">{{ $t('other.a91') }}</el-button></div>
							<div class="ordersn-box">{{ $t('homeTwo.Logistics') }}：{{ scope.row.logistics }}</div>
							<div class="ordersn-box">{{ $t('homeTwo.Waybillnumber') }}：
								<span v-if="scope.row.trackingNo">{{ scope.row.trackingNo }}</span>
								<span v-else>{{ $t('other.a985') }}</span>
							</div>
							<div class="ordersn-box" v-if="scope.row.orderPdf">{{ scope.row.orderPdf.initType == 1 ? 'Pick Up' : 'Drop Off' }}</div>
							<div class="ordersn-box" style="color:red" v-if="scope.row.loadingType == 1">{{
								scope.row.orderPdf ? scope.row.orderPdf.msg : '' }}</div>
							<div class="ordersn-box" v-show="scope.row.platform == 'DXS'"><el-button size="mini"
									type="primary" @click="getDataLogistic(scope.row)">{{ $t('other.a1039') }}</el-button>
							</div>
							<div class="ordersn-box" v-show="userPage"><el-button size="mini" type="primary"
									@click="getDataLogistic(scope.row)">{{ $t('other.a1040') }}</el-button></div>
									
							<div class="ordersn-box">{{ $t('homeTwo.Shippingwarehouse') }}：
								<!-- <span v-if="scope.row.items&&scope.row.items.length>0">{{ scope.row.items[0].platformInventoryDeductionWarehouseName }}</span> -->
								<span>{{ scope.row.warehouseName}}</span>
								<!-- <span v-for="(item,index) in scope.row.items">{{ item.platformInventoryDeductionWarehouseName }}<span v-if="index!=scope.row.items.length-1">,</span> </span> -->
							</div>

						</template>
					</el-table-column>
					<!-- <el-table-column label="Pick Time" >
						<template slot-scope="scope">
							<div>{{scope.row.orderId }}</div>
						</template>
					</el-table-column> -->
					<el-table-column label="Status">
						<template slot-scope="scope">
							<div style="color: red;">{{ scope.row.packaged ? $t('orderPrint.Packaged') :
								$t('orderPrint.Unpackaged') }}</div>
							<div style="color: red;">{{ scope.row.printNum > 0 ? $t('orderPrint.Printed') :
								$t('orderPrint.To_print') }}</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="Pager">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[15, 30, 50, 100, 200]" :page-size="offset"
					layout="total, sizes, prev, pager, next, jumper" :total="totalList">
				</el-pagination>
			</div>
		</div>
		<div class="downloadTips" v-if="downloadShow">
			<i class="el-icon-loading"></i>
			{{ $t('other.a3420') }}
			<!-- 图片生成中：{{ downloadIndex }}/{{ downloadData.length }} -->
			<!-- <el-progress type="circle" :percentage="downloadpercentage"></el-progress> -->
		</div>
		<!-- <div class="downloadBox downloadBoxT"></div> -->
		<!-- <div class="downloadBox" ref="downloadBox" v-if="downloadData.length>0&&false">
			<div class="downloadUL" :ref="'downloadUL'+index" v-for="(item,index) in downloadData" v-if="downloadIndex == index" :key="item.orderText+new Date().getTime()">
				<div class="downloadTop">
					<div :id="'barcodeImg'+index"></div>
					<img @load="ChangeDownloadImg(index)" :src="item.image" alt="" srcset="" :key="item.image+new Date().getTime()">
					<div>{{ item.orderText }}</div>
					<div>{{ item.itemSku }};{{ item.variationSku }}</div>
				</div>
				<div class="downloadContent">
					<img @load="ChangeDownloadImg(index)" :src="item.pintImage" alt="" srcset="" :key="item.image+new Date().getTime()">
				</div>
			</div>
		</div> -->
		<canvas id="canvasImg" ref="canvasImg">

		</canvas>
	</div>
</template>

<script>



import JSZip from 'jszip';
import axios from 'axios';
import { saveAs } from 'file-saver';
import html2canvas from 'html2canvas'
// import QRCode from 'qrcodejs2'
import QRCode from 'qrcode'
import Condition from '../../../components/condition'
import Dialog from '../../../components/dialog/dialog.vue'
import TableDia from './components/table'
import newOrdersApi from '../../../api/moudles/newOrders'
import orders from '../../../api/moudles/order'
import utils from '../../../utils/utils'
import loading from '../../../components/loadingTip'
import config from '../config.js'
import printApi from '../../../api/moudles/print.js'
import FlagPlugin from '../../../components/flag.vue'
import { mapState, mapActions, mapMutations } from 'vuex'
import { JudegeSensitive, JudegeBindStore } from '../../../utils/toolFun'
import newOrders from '../../../api/moudles/newOrders'
import api from '../../../api/api'
import { showLoading } from '../../../assets/js/loading'
export default {
	data() {
		return {
			labelPosition: 'right',
			formLabelAlign: {
				name: '',
				phone: '',
				address: ''
			},
			information: false,
			getDataParams: {},
			userPos: JSON.parse(localStorage.getItem('userInfo')).userPos,
			allstoreIds: JSON.parse(localStorage.getItem('userInfo')).storeIds,
			allshopIds: JSON.parse(localStorage.getItem('userInfo')).shopIds,
			userPage: JSON.parse(localStorage.getItem('userInfo')).userPage ? JSON.parse(localStorage.getItem('userInfo')).userPage.page4 : false,
			orderlist: [],
			setFlagsList: [],
			multipleSelection: [],
			mapList: [],
			btnlist: [],
			totalList: 0,

			percentage: 0,
			hasGenerateNum: 0,
			activeIndex: [],
			textarea: null,
			target: 'all',
			viewFaileDetail: false,
			offset: 50,
			showFastBtn: true,
			printHistorDia: false,
			currentPage: 1,
			page: 1,
			list: [],
			searchOrderId: '',
			reasonOptions: [],
			reasonReturn: '',
			sortType: '7',
			searchName: '',
			importHeaders: { token: JSON.parse(localStorage.getItem('userInfo')).token },
			userArea: JSON.parse(localStorage.getItem('userInfo')).country,
			printedvisabable: false,
			printedUrl: [],
			itemTargetList: [],
			fileList: [],
			isFlage: false,
			flashPage: config.flagList,
			activeBtnIndex: ['all', 0, 0],
			isNotify: false,
			failErrorOrder: [],
			itemKey: 0,
			successTotal: 0,
			chooseAll: false,
			Systemtext: null,
			systemDia: false,
			dialogVisibleImg: false,
			dialogImageUrl: '',
			hasData: false,
			currencyoptions: [],
			managementAdrress: false,
			tip: this.$t('other.a989'),
			currenTenoclock: null,
			openReceiveDialog: false,
			diaReturnOrder: false,
			receiveItems: null,
			dialogVisible: false,
			logisticsOption: [],
			DxsObjParams: {
				height: null,
				length: null,
				orderId: null,
				shopId: null,
				storeId: null,
				userId: null,
				weight: null,
				width: null,
				ruleId: null,
				actualCost: null,
				imgUrls: null,
				trackingNo: null,
				currency: null
			},
			rules: {
				height: [
					{ required: true, message: this.$t('other.a1041'), trigger: 'blur' },
				],
				length: [
					{ required: true, message: this.$t('other.a1042'), trigger: 'blur' },
				],
				width: [
					{ required: true, message: this.$t('other.a1043'), trigger: 'blur' },
				],
				ruleId: [
					{ required: true, message: this.$t('other.a1044'), trigger: 'blur' },
				],
				weight: [
					{ required: true, message: this.$t('other.a1045'), trigger: 'blur' },
				],

			},
			tableKey: new Date().getTime(),
			downloadData:[],
			downloadIndex:0,
			downloadShow:false,
			downloadArr:[],
			downloadArrIndex:0,
			downloadpercentage:0
		}
	},
	components: {
		FlagPlugin,
		loading,
		Dialog,
		TableDia
	},
	computed: {
		...mapState({
			userId: state => state.shopaccess.userInfo.userId,
		}),



		storePending() {
			return this.$t('storePending')
		},

		listData() {
			// let ttp =false
			let ttp = this.activeIndex[15] == 0 ? false : this.activeIndex[15] == 1 ? true : false
			let list = []
			console.log(ttp,'===>ttp')
			if (this.mapList.length) {
				list = this.mapList[15].get(ttp)
			}

			
			let ttp1 = this.activeIndex[16] == 1 ? true : this.activeIndex[16] == 2 ? false : null
			if (this.activeIndex[16]!=0&&this.mapList.length) {
			list = this.mapList[16].get(ttp1)
			}



			this.totalList = list.length
			let arr2 = []
			let list2 = []



			//先按订单号查找
			if (this.searchOrderId.length > 0) {
				//对订单号筛选，筛选完之后的订单数据就在list3
				list.forEach((order) => {
					if (this.searchOrderId.length > 0) {
						if (order.orderId == this.searchOrderId.trim() || order.trackingNo == this.searchOrderId.trim()) {
							list2.push(order)
						}
					} else {
						list2 = list;
					}
				})
			} else if (this.searchName.length > 0) {
				//订单的包含查询
				list.forEach((order) => {
					// console.log(order)
					// console.log("===4444")
					order.items.forEach(k => {
						// console.log(k)
						// console.log("===231313")
						if (this.searchName.length > 0) {
							if ((k.storeItem && k.storeItem.cusCode) == this.searchName.trim() || order.printTime == this.searchName.trim() || order.auditTime == this.searchName.trim() || order.auditTime == this.searchName.trim() || this.fuzzyMatch(k.itemName, this.searchName.trim()) || this.fuzzyMatch(k.variationSku, this.searchName.trim()) || this.ujgnkjv(k.storeItem, this.searchName.trim()) || this.fuzzyMatch(k.storeItem ? k.storeItem.itemSku : null, this.searchName.trim()) || this.fuzzyMatch(k.storeItem ? k.storeItem.skuName : null, this.searchName.trim()) || this.fuzzyMatch(k.itemKey, this.searchName.trim())) {

								arr2.push(order)

							}
						} else {
							arr2 = list;
						}
					})
				})

				//数组去重
				let obj = {}
				list2 = arr2.reduce((cur, next) => {
					obj[next.orderId] ? '' : obj[next.orderId] = true && cur.push(next)
					return cur
				}, [])
				console.log('list2', list2)


			} else {
				list2 = list

			}




			//订单排序
			list2.sort((a, b) => {
				if (this.sortType == 1) {
					return new Date(a.createTime) - new Date(b.createTime)
				}
				if (this.sortType == 2) {
					return new Date(b.createTime) - new Date(a.createTime)
				}
				if (this.sortType == 3) {
					if (b.itemNum == 1 && a.itemNum == 1)
						if (a.items[0].itemId == b.items[0].itemId) {
							if (a.items[0].variationId == b.items[0].variationId) {
								return b.itemAmount - a.itemAmount
							} else {
								return a.items[0].variationId - b.items[0].variationId
							}
						} else {
							return a.items[0].itemId - b.items[0].itemId
						}
					return b.itemAmount - a.itemAmount

				}
				if (this.sortType == 4) {
					if (b.itemNum == 1 && a.itemNum == 1)
						if (a.items[0].itemId == b.items[0].itemId) {
							if (a.items[0].variationId == b.items[0].variationId) {
								return a.itemAmount - b.itemAmount
							} else {
								return a.items[0].variationId - b.items[0].variationId
							}
						}
					return a.itemAmount - b.itemAmount
				}
				if (this.sortType == 5) {//sku由多到少
					return b.itemNum - a.itemNum
				}
				if (this.sortType == 6) {//sku由少到多
					if (b.itemNum == a.itemNum) {
						let aStoreItem = a.items[0].storeItem
						let bStoreItem = b.items[0].storeItem
						if (aStoreItem == null) {
							return -1;
						}
						if (bStoreItem == null) {
							return -1;
						}
						if (aStoreItem.groupId == bStoreItem.groupId) {
							if (aStoreItem.cusCode == bStoreItem.cusCode) {
								return a.items[0].variationQuantityPurchased - b.items[0].variationQuantityPurchased
							}

							return aStoreItem.cusCode - bStoreItem.cusCode;
						}
						return aStoreItem.groupId - bStoreItem.groupId
					}
					return a.itemNum - b.itemNum
				}

				if (this.sortType == 7) {
					return new Date(a.auditTime) - new Date(b.auditTime)

				}

				if (this.sortType == 8) {
					return new Date(b.auditTime) - new Date(a.auditTime)
				}
				return a.itemNum - b.itemNum
			})


			this.totalList = list2.length
			// 订单分页
			console.log((this.page - 1) * this.offset, (this.page) * this.offset)
			let list3 = list2.slice((this.page - 1) * this.offset, this.page * this.offset)
			console.log('list3', list3)

			this.tableKey = new Date().getTime();

			return list3
			console.log(ttp)

		}



	},
	inject: ['reload'],
	watch: {

		dialogVisible() {
			if (!this.dialogVisible) {
				this.DxsObjParams.height = null
				this.DxsObjParams.length = null
				this.DxsObjParams.orderId = null
				this.DxsObjParams.weight = null
				this.DxsObjParams.width = null
				this.DxsObjParams.ruleId = null
				this.DxsObjParams.actualCost = null
				this.DxsObjParams.trackingNo = null
				this.DxsObjParams.currency = null

			}
		},
		isNotify() {
			if (!this.isNotify) {
				this.successTotal = 0
				this.failErrorOrder = []
				this.percentage = 0
			}
		},

	},
	created() {
		this.getTenTime()
		this.init()
		this.getNotHandlePages()
		this.getUserFlags({ userId: this.userId })


	},
	methods: {
		...mapActions('lazadaorders', [
			'getLazadaOrderByuserid'
		]),

		...mapActions('order', [
			'getUnprocessOrder', //获取所有商店待处理订单
			'auditOrder',
			'getPrintOrder', //打印订单
			'getOrdersBytrickNo',
			'getInitOrderBypickup',
			'getInitOrderBydropoff',
			'updatShopAllOrders',

			'getSpeciesOrder',
			'getGoodsOrder',
			'getLogistics',
			'addPrintTimes',
			'getPrintSheetHistory',
			'getPrintTogether',
			'storeReceived',
			'regeneratePDF',
			'getGoodsTypeByStore'

		]),
		...mapMutations('order', [
			'SET_ORDER_FINISH',
		]),


		...mapActions('print', [
			'getUserFlags',


		]),
		...mapActions('mygoods', [
			'tongBuShopee',
		]),

		handlePreview(file) {
			console.log(file);
		},

		handleRemove(file, fileList) {
			console.log(file, fileList);
		},
		getUserAddress() {
			let params = {
				// cacheData:JSON.stringify(this.formLabelAlign),
				cacheKey: this.userId + '_' + 'Shipper_Address',
				userId: this.userId
			}
			api
				.getUserCache(params)
				.then(res => {

					if (res.code === 200) {

						if (res.data) {
							this.formLabelAlign = JSON.parse(res.data.cacheData)

						} else {
							this.$message.warning(this.$t('other.a992'))

							setTimeout(() => {
								this.information = true;
							}, 1000);
						}

					} else {
						this.$message.warning(res.msg)
					}
				})
		},//获取发货详细信息
		showinformation() {
			this.information = true;

		},
		chckeformation() {
			let params = {
				cacheData: JSON.stringify(this.formLabelAlign),
				cacheKey: this.userId + '_' + 'Shipper_Address',
				userId: this.userId
			}

			api
				.setUserCache(params)
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
						this.$message.success(this.$t('other.a993'))
						this.getUserAddress();
						this.information = false;
					} else {
						this.$message.warning(res.msg)
					}
				})

			console.log(params)
			// this.essential.push(this.formLabelAlign)
			// console.log(JSON.stringify(this.formLabelAlign));
			// localStorage.setItem('userAddress',JSON.stringify(this.formLabelAlign));
			// this.information = false;

			// let params={
			// 	cacheData:JSON.stringify(this.formLabelAlign),
			// 	cacheKey:this.userId+'address',
			// 	userId:this.userId
			// }
			// api
			// .getUserCache(params)
			// .then(res => {
			// if(res.code === 200 ){



			// }else{
			// this.$message.warning(res.msg)
			// }
			// })
		},
		handleClose() {
			this.information = false;
		},
		generateLogisticOrder() {
			this.$refs.form.validate((valid) => {
				if (valid) {
					this.DxsObjParams.height = Number(this.DxsObjParams.height)
					this.DxsObjParams.length = Number(this.DxsObjParams.length)
					this.DxsObjParams.weight = Number(this.DxsObjParams.weight)
					this.DxsObjParams.width = Number(this.DxsObjParams.width)
					this.DxsObjParams.actualCost = Number(this.DxsObjParams.actualCost)
					this.DxsObjParams.trackingNo = this.DxsObjParams.trackingNo


					console.log(this.DxsObjParams)

					newOrders
						.createDxsLogisticsOrder(this.DxsObjParams)
						.then(res => {
							if (res.code === 200) {
								console.log('desc', res.data)
								this.$message.success(this.$t('other.a1046'))
								this.dialogVisible = false
							} else {
								this.$message.warning(res.msg)
							}
						})


				} else {
					this.$message.warning(this.$t('other.a1047'))
					return false;
				}
			});
		},



		getDataLogistic(item) {
			this.currencyoptions = utils.gerCurrency()
			let country = JSON.parse(localStorage.getItem('userInfo')).stores.find(p => p.storeId == item.storeId).storeAddress
			console.log('storeid', country)
			this.DxsObjParams.currency = this.currencyoptions.find(item => item.desc === country).value
			console.log('storeid', country)
			this.DxsObjParams.shopId = item.shopId
			this.DxsObjParams.storeId = item.storeId
			this.DxsObjParams.userId = this.userId
			this.DxsObjParams.orderId = item.orderId
			this.DxsObjParams.ruleId = item.messageToSeller ? Number(item.messageToSeller) : null,
				this.DxsObjParams.msgToStore = item.msgToStore ? item.msgToStore : this.$t('other.a1048'),



				newOrders
					.getLogisticsRuleByStore({ storeId: item.storeId })
					.then(res => {
						if (res.code == 200) {
							console.log(res.data)
							this.logisticsOption = res.data
							this.dialogVisible = true
						} else {
							this.$message.warning(res.msg)
						}
					})
		},

		inputOrderInfo(item) {
			console.log(item)
			this.getGoodsTypeByStore({
				orderId: item.orderId
			})
			this.openReceiveDialog = true
			this.receiveItems = item
		},

		justStoreTypeCopy(id) {
			return utils.judgeTestStore(id)
		},

		getTenTime() {
			let now_data = new Date(new Date(new Date().toLocaleDateString()).getTime() + 10 * 60 * 60 * 1000 - 3)
			this.currenTenoclock = utils.renderTime(now_data)
			console.log('currenTenoclock', this.currenTenoclock)

		},

		compareTime(startTime, endTime) {

			var start_time = startTime.replace(/-|\s|:|\//g, '');
			var end_time = endTime.replace(/-|\s|:|\//g, '');
			if (start_time < end_time) { return true; }
			else { return false; }

		},


		time_to_sec(time) {
			if (time !== null) {
				var s = "";
				var hour = time.split(":")[0];
				var min = time.split(":")[1];
				var sec = time.split(":")[2];
				s = Number(hour * 3600) + Number(min * 60) + Number(sec);
				return s;
			}
		},

		choiceshopId() {
			console.log(this.sortType)
		},

		refleshPage() {
			this.printedvisabable = false
			this.init()
			this.getNotHandlePages()
		},
		ujgnkjv(storeItem, str) {

			let falg = false
			if (storeItem) {
				if (storeItem.component == false) {
					storeItem.children.forEach(p => {
						if (p.address === str) {
							falg = true
						}
					})
				} else {
					falg = storeItem.address === str
				}


			}

			return falg
		},

		fuzzyMatch(str, key) {

			str == null ? '' : str
			if (typeof (str) == Number) {
				return str == key
			}

			if (str) {

				str = str.toUpperCase()
				key = key.toUpperCase()
				let ttp = false
				if (str.indexOf(key) != -1 || str == key) {
					ttp = true
				}
				return ttp


			} else {
				return false;
			}
		},

		extportOrderInfo() {
			let arr = []
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a716'))
				return
			}
			console.log(this.multipleSelection)
			this.multipleSelection.forEach(p => {
				p.items.forEach((k, index) => {
					k.totalSku = ''
					k.totalQty = 0
					let num = index + 1
					if (k.storeItem && k.storeItem.component) {//单品
						k.totalSku = 'sku1' + ':' + k.storeItem.skuName + ' */Qty:' + k.variationQuantityPurchased
						k.totalQty = k.variationQuantityPurchased
					} else {//套餐
						if (k.storeItem && k.storeItem.children) {
							k.storeItem.children.forEach((j, ttb) => {
								let vdf = ttb + 1
								k.totalSku += 'sku' + vdf + '(' + j.cusCode + ')' + ':' + j.skuName + ' */Qty:' + k.variationQuantityPurchased * j.rate
								k.totalQty += j.rate * k.variationQuantityPurchased
							})
						}
					}

					// console.log(p)
					arr.push({
						'订单号': p.orderId,
						'运单号': p.trackingNo,
						'收货人': p.address.name,
						'电话号码': p.address.phone,
						'详细地址': p.address.state + '/' + p.address.city + '/' + p.address.fullAddress,
						'产品名称': k.itemName,
						'单品或套餐': k.storeItem ? k.storeItem.component ? this.$t('other.a251') + k.storeItem.cusCode : this.$t('other.a252') + k.storeItem.cusCode : this.$t('other.a568'),
						'sku详情': k.totalSku,
						'sku数量': k.storeItem ? k.storeItem.component ? 1 : k.storeItem.children.length : this.$t('other.a568'),
						'购买总数': k.totalQty,
						'实收': k.price,
						'配送方式': p.logistics,
						'下单时间': utils.renderTime(p.createTime),
						// '发货仓库': k.platformInventoryDeductionWarehouseName,
						'发货仓库': p.warehouseName,
					})
				})
			})
			let list = ['订单号', '运单号', '收货人', '电话号码', '详细地址', '产品名称', '单品或套餐', 'sku详情', 'sku数量', '购买总数', '实收', '配送方式', '下单时间','发货仓库']
			console.log('arr', arr)
			utils.exPortEXml(arr, list, list)

			this.multipleSelection.forEach(item => {
				item.checked = false
			})
		},

		returnOrderCopy() {
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a716'))
				return
			}
			if (!this.textarea) {
				this.$message.warning(this.$t('other.a1049'))
				return
			}

			let list = this.multipleSelection.map(p => {
				return {
					orderId: p.orderId,
					shopId: p.shopId,
					storeId: p.storeId,
					userId: this.userId,
					msg: this.textarea
				}
			})

			console.log(list)

			newOrdersApi
				.cancelAuditedOrders(list)
				.then(res => {
					if (res.code === 200) {
						this.$message.success(this.$t('other.a1002'))

						setTimeout(() => {
							let list = JSON.parse(JSON.stringify(this.mapList[0].get('all')))
							this.multipleSelection.forEach(p => {
								let num = list.findIndex(i => i.orderId === p.orderId)
								list.splice(num, 1)
							})

							console.log('list', list)
							this.orderClassification(list, -1)
							this.handleBtn(this.activeBtnIndex[0], this.activeBtnIndex[1], this.activeBtnIndex[2])
						}, 500)
					} else {
						this.$message.warning(res.msg)
					}
				})
		},

		returnOrder() {
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a716'))
				return
			}

			this.$confirm(this.$t('other.a1000') + this.multipleSelection.length + this.$t('other.a1001'), this.$t("other.a142"), {
				confirmButtonText: this.$t('other.a145'),
				cancelButtonText: this.$t('other.a146'),
				type: 'warning'
			}).then(() => {
				let list = this.multipleSelection.map(p => {
					return {
						orderId: p.orderId,
						shopId: p.shopId,
						storeId: p.storeId,
						userId: this.userId
					}
				})
				newOrdersApi
					.cancelAuditedOrders(list)
					.then(res => {
						if (res.code === 200) {
							this.$message.success(this.$t('other.a1002'))

							setTimeout(() => {
								let list = JSON.parse(JSON.stringify(this.mapList[0].get('all')))
								this.multipleSelection.forEach(p => {
									let num = list.findIndex(i => i.orderId === p.orderId)
									list.splice(num, 1)
								})

								console.log('list', list)
								this.orderClassification(list, -1)
								this.handleBtn(this.activeBtnIndex[0], this.activeBtnIndex[1], this.activeBtnIndex[2])
							}, 1000)
						} else {
							this.$message.warning(res.msg)
						}
					})

				console.log(list)
			})
		},

		getDesc(id) {


			let ttp = this.flashPage.filter(p => p.flagId == id)

			if (ttp.length) {
				return ttp[0].desc
			} else {
				return this.$t("other.a354")
			}



		},

		editMark(item) {
			if (this.userPos == 'SELLER') {
				console.log(item)
				this.isFlage = true
				this.multipleSelection = [item]
			}


		},

		showFlage(id) {
			let arr = []
			if (this.flashPage.length > 0) {
				this.flashPage.forEach(p => {
					if (p.colorId === id) {
						p.style.width = '20px'
						p.style.height = '20px'
						arr.push(p)
					}
				})
				return arr
			}
		},

		toggleSelection() {
			this.chooseAll = !this.chooseAll
			let rows = this.listData
			if (this.chooseAll) {
				this.$refs.multipleTable.clearSelection();
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row)
				})
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},

		synchronizeProducts() {
			//同步商品
			let TEMUShopArr = utils.onlyGetTEMUshop()
			console.log(TEMUShopArr)
			const loading = this.$loading({
				lock: true,
				text: '同步中',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			for (let i = 0; i < TEMUShopArr.length; i++) {
				this.tongBuShopee({
					shopId: TEMUShopArr[i].value,
					userId: this.userId
				}).then(res => {
					loading.close();
					if (res.code === 200) {
						if (i == TEMUShopArr.length - 1) {
							this.$message.success(this.$t('other.a2405'))
						}
					} else {
						if (i == TEMUShopArr.length - 1) {
							this.$message.error(res.msg)
						}
					}
				}).catch(err => {
					loading.close();
				})
			}
		},
		SynchronizeCheck() {
			console.log(this.multipleSelection)
			if (!this.multipleSelection.length) {
				this.$message.warning('请选择需要紧急同步的订单，可多选订单')
				return
			}
			let arr = []
			let arrShopIds = []
			for (let i = 0; i < this.multipleSelection.length; i++) {
				let index = arrShopIds.indexOf(this.multipleSelection[i].shopId)
				if (index == -1) {
					arr.push({
						shopId: this.multipleSelection[i].shopId,
						orderIds: [this.multipleSelection[i].orderId]
					})
					arrShopIds.push(this.multipleSelection[i].shopId)
				} else {
					arr[index].orderIds.push(this.multipleSelection[i].orderId)
				}
			}
			console.log(arr)
			let data = {
				updateOrdersParam: arr
			}
			const loading = this.$loading({
				lock: true,
				text: '同步中',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			orders.updateShopOrdersById(data).then(res => {
				loading.close();
				if (res.code === 200) {
					this.multipleSelection.forEach(item => {
						item.checked = false
					})
					this.$message.success(this.$t('other.a2405'))
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				loading.close();
			})
		},
		Synchronize(num) {
			let start_time = ''
			let end_time = ''
			if (num === 0) {
				start_time = utils.getRecentDays(-3);
				end_time = utils.getRecentDays(0);
			} else if (num === 1) {
				start_time = utils.getRecentDays(-7);
				end_time = utils.getRecentDays(0);
			} else if (num === 2) {
				start_time = utils.getRecentDays(-30);
				end_time = utils.getRecentDays(0);
			}

			const arr = {
				end: end_time,
				start: start_time,
				shopIds: JSON.parse(localStorage.getItem('userInfo')).shopIds,
				userId: this.userId
			}
			console.log(arr)
			console.log(this.idShop)
			this.$message.warning(this.$t('other.a798'))
			setTimeout(() => {
				this.updatShopAllOrders({
					payload: arr,
					text: this.$t('other.a1003')
				})
			}, 1000)


		},

		updata() {
			utils.updateInfoByCache({
				cacheKey: 'userAddress',
				userId: this.userId,
				cacheData: JSON.stringify(this.list)
			})
		},

		setDefult(item, index, num) {
			if (num == 0) {
				this.list.forEach(p => {
					p.defaultFrom = false
				})
				item.defaultFrom = !item.defaultFrom
				console.log(item)
			} else {
				this.list.forEach(p => {
					p.defaultReceive = false
				})
				item.defaultReceive = !item.defaultReceive
			}
			this.updata()

			this.itemKey++
		},


		setFlags(val) {//发送设置旗帜的请求，同时将页面的每个订单插上旗帜

			console.log(val)

			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a716'))
				return
			}


			let arr = this.mapList[0].get('all')
			arr.forEach(p => {
				this.multipleSelection.forEach(i => {
					if (p.orderId === i.orderId) {
						p.flagId = val.flagId
					}
				})
			})


			arr.forEach(p => {
				p.flagId = p.flagId == null ? 0 : p.flagId

			})
			console.log('arr', arr)



			this.orderClassification(arr, -1)



			let params = {
				flagId: val.flagId,
				orderIds: this.multipleSelection.map(p => { return p.orderId })
			}

			let list = [{
				color: val.colorId,
				describe: val.desc,
				isChoose: 1,
				userId: this.userId
			}]

			this.updatFlagDesc(list)

			newOrdersApi
				.setOrderFlag(params)
				.then(res => {
					if (res.code === 200) {
						console.log('设置标记', res.data)
						this.handleBtn(this.activeBtnIndex[0], this.activeBtnIndex[1], this.activeBtnIndex[2])
					} else {
						this.$message.warning(res.msg)
					}
				})
		},

		updatFlagDesc(params) {
			printApi
				.updataUserFlageDesc(params)
				.then(res => {
					if (res.code === 200) {
						console.log('更新旗帜描述', res.data)
					}
				})
		},

		conversion(key, index) {
			let ttp = null
			if (index == 0) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key == 'DXS' ? this.$t('other.a1004') : key
				}
			} else if (index == 1) {
				ttp = key === 'all' ? this.$t('storePending').all : key ? this.$t('other.a785') : this.$t('other.a784')
			} else if (index == 3) {
				ttp = key === 'all' ? this.$t('storePending').all : utils.showShopNameByshopId(key)
			} else if (index == 2) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key
				}
			} else if (index == 4) {
				ttp = key === 'all' ? this.$t('storePending').all : key ? '分销订单' : this.$t('other.a781')
			} else if (index == 5) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key == 0 ? this.$t('storePending').notgenerated : key == 1 ? this.$t('storePending').loading : this.$t('storePending').Generated
				}

			} else if (index == 6) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key == true ? this.$t('storePending').printed : this.$t('storePending').notprinted
				}

			} else if (index == 7) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key
				}

			} else if (index == 8) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key == 99999 ? this.$t('other.a1005') : key == null || key == 0 ? this.$t('other.a1006') : key
				}

			} else if (index == 9) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key
				}

			} else if (index == 10) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key == true ? this.$t('homeTwo').urgent : this.$t('other.a1050')
				}

			} else if (index == 11) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key == true ? this.$t('storePending').yes : this.$t('storePending').notYet
				}

			} else if (index == 12) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key == true ? this.$t('storePending').singlesku : this.$t('storePending').multiplesku
				}

			} else if (index == 13) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key == true ? this.$t('storePending').noEnough : this.$t('storePending').Enough
				}

			} else if (index == 14) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key == true ? this.$t('storePending').tenBefore : this.$t('storePending').tenAfter
				}

			} else if (index == 15) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key == true ? this.$t('storePending').enptry : this.$t('storePending').norMall
				}

			} else if (index == 16) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key == true ? '有打印图' : '无打印图'
				}

			} else {
				return key
			}


			return ttp
		},

		showFlageStyle(id) {
			console.log('id', id)
			console.log('flashPage', this.flashPage)
			let ttp = this.flashPage.find(item => item.colorId == id)
			if (ttp) {
				return ttp.style
			} else {
				return ''
			}
			console.log('ttp', ttp)
			// return ttp
		},
		systemAdmin() {

			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a716'))
				return
			}
			this.isNotify = true
			let list = this.multipleSelection.map(p => {
				return {
					orderId: p.orderId,
					shopId: p.shopId,
					type: 1,
					userId: this.userId
				}
			})

			this.multipleSelection.forEach(p => {
				this.itemTargetList.push(p.orderId)
			})

			console.log('list', list)

		},
		//开始生成运单号
		startReadyOrders(num) {
			console.log(this.multipleSelection)
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a716'))
				return
			}
			this.isNotify = true
			let list = this.multipleSelection.map(p => {
				return {
					orderId: p.orderId,
					shopId: p.shopId,
					type: num,
					userId: this.userId
				}
			})

			this.multipleSelection.forEach(p => {
				this.itemTargetList.push(p.orderId)
			})
			// this.getNewOrdersInfo(this.itemTargetList)

			newOrdersApi
				.sartReadyOrders(list)
				.then(res => {
					if (res.code === 200) {
						// 将要轮询的订单号暂存起来
						this.itemTargetList = this.multipleSelection.map(p => {
							return p.orderId
						})
						this.getNewOrdersInfo(this.itemTargetList)

					} else {
						this.$message.warning(res.msg)
					}
				})

			console.log('list', list)
		},



		//轮询运单号是否生成
		getNewOrdersInfo(list) {
			newOrdersApi
				.getNewOrders(list)
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
						let allOrderlist = this.multipleSelection.length
						res.data.forEach(p => {
							if (p.trackingNo) {
								if (allOrderlist > this.successTotal) {
									setTimeout(() => {
										this.successTotal += 1
										this.percentage = parseInt(this.successTotal / allOrderlist * 100)
										console.log('percentage', this.percentage)
									}, 1000)
								}
								let indexNum = this.itemTargetList.findIndex(item => item == p.orderId)
								console.log(indexNum)
								this.itemTargetList.splice(indexNum, 1)

							} else {

								if (p.orderPdf || p.orderPdf.msg) {
									this.failErrorOrder.push(p)
									if (allOrderlist > this.failErrorOrder.length - 1) {
										setTimeout(() => {
											this.successTotal += 1
											this.percentage = parseInt(this.successTotal / allOrderlist * 100)
											console.log('percentage', this.percentage)
										}, 1000)
									}
									let indexNum = this.itemTargetList.findIndex(item => item == p.orderId)
									this.itemTargetList.splice(indexNum, 1)
								}
							}

						})

						console.log(this.itemTargetList)
						setTimeout(() => {
							if (this.itemTargetList.length) {
								this.getNewOrdersInfo(this.itemTargetList)
							} else {
								this.$message.success(this.$t('other.a904'))

								console.log('failErrorOrder', this.failErrorOrder)
								// setTimeout(() => {
								// 	this.init()
								// 	this.getNotHandlePages()
								// },500)
							}

						}, 1000)


					} else {
						this.$message.warning(res.msg)
					}
				})
		},
		//打印备货单
		goStockList() {
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a716'))
				return
			}
			utils.cleanStorageData()
			let list = this.multipleSelection.map(p => {
				return p.orderId
			})

			let obj = {
				userId: this.userId,
				orderIds: list.join(),
				platform: this.activeIndex[0] == 0 ? 'SHOPEE' : 'LAZADA',
				createTime: null,
				printType: '1',
			}

			this.insterPrintRecode(obj)


			localStorage.setItem('stockingInfoCopy', JSON.stringify(list))

			let routeData2 = this.$router.resolve({
				name: "productStockling",
				query: {
					flag: this.activeIndex[0]
				}
			})
			window.open(routeData2.href, '_blank');
		},

		insterPrintRecode(obj) {
			newOrdersApi
				.insertPrintHistory(obj)
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
					} else {
						this.$message.warning(res.msg)
					}
				})
		},

		showhistoryRecord() {
			this.printHistorDia = true
		},


		// 打印默认拣货单
		mergerPrintPicklist() {
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a716'))
				return
			}

			utils.cleanStorageData()
			let list = this.multipleSelection.map(p => {
				return p.orderId
			})

			let obj = {
				userId: this.userId,
				orderIds: list.join(),
				createTime: null,
				printType: '0',
				platform: this.activeIndex[0] == 0 ? 'SHOPEE' : 'LAZADA',
			}


			this.insterPrintRecode(obj)
			localStorage.setItem('picklistInfoCopy', JSON.stringify(list))

			const { href } = this.$router.resolve({
				name: 'productPicklist',

			})
			window.open(href)

		},


		printPicklist(item) {
			console.log(item)
			let list = item.orders

			let obj = {
				userId: this.userId,
				orderIds: item.orders.join(),
				createTime: null,
				printType: '0',
				platform: this.activeIndex[0] == 0 ? 'SHOPEE' : 'LAZADA',
			}


			this.insterPrintRecode(obj)

			localStorage.setItem('picklistInfoCopy', JSON.stringify(list))

			const { href } = this.$router.resolve({
				name: 'productPicklist',

			})
			window.open(href)

		},




		gotoprint(item) {
			console.log(item)
			item.hasPrined = true
			if (item.platform == 'SHOPEE') {
				item.urlCopy.forEach(p => {
					window.open(p)
				})
			}

			if (item.platform == 'LAZADA') {

				let Base64 = require('js-base64').Base64
				let file = item.urlCopy.data.document.file
				let newfile = Base64.decode(file)
				localStorage.removeItem('alipay')
				localStorage.setItem('html', newfile)
				let newUrl = location.host + '/sealpage'
				console.log(newUrl)
				window.open('https://' + newUrl)

			}

			let obj = {
				userId: this.userId,
				orderIds: item.orders.join(),
				createTime: null,
				printType: '2',
				platform: this.activeIndex[0] == 0 ? 'SHOPEE' : 'LAZADA',
			}


			this.insterPrintRecode(obj)

			this.addPrintNum(item.orders)
		},

		addPrintNum(list) {
			newOrdersApi
				.addPrintNum(list)
				.then(res => {
					if (res.code === 200) {
						console.log('增加了打印次数！')
					} else {
						console.log('增加了打印次数！', res.msg)
					}
				})

		},


		printFastOrderLACopy() {
			let list = this.multipleSelection.map(p => { return p.orderId })
			localStorage.setItem('unprocessedOrderIds', JSON.stringify(list))

			let routeData2 = this.$router.resolve({
				name: "productLazadaPicklist",
			})
			window.open(routeData2.href, '_blank');
		},

		printDefaultOrderCopy() {
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a1008'))
				return
			}

			let flag = false
			this.multipleSelection.forEach(p => {
				if (!p.trackingNo || !p.ready || !p.sent) {
					flag = true
				}
			})

			if (flag) {
				this.$message.warning(this.$t('other.a1051'))
				return
			}

			console.log(this.multipleSelection)
			this.$confirm(this.$t('other.a1052'), this.$t("other.a142"), {
				confirmButtonText: this.$t('other.a1053'),
				cancelButtonText: this.$t('other.a146'),
				type: 'warning'
			}).then(() => {
				let list = this.multipleSelection.map(p => { return p.orderId })
				newOrdersApi
					.getOrderBillUrl(list)
					.then(res => {
						if (res.code === 200) {
							console.log('面单地址', res.data)
							let list = []
							let orderList = []
							res.data.forEach(p => {
								p.url = JSON.parse(p.url)
								list.push(...p.url)
								orderList.push(...JSON.parse(p.ordersn))
								window.open(p.url[0])
							})

							this.addPrintNum(orderList)

						} else {
							this.$message.warning(res.msg)
						}
					})
			})


		},




		printDefaultOrder() {
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a1008'))
				return
			}
			let list = this.multipleSelection.map(p => { return p.orderId })
			newOrdersApi
				.getOrderBillUrl(list)
				.then(res => {
					if (res.code === 200) {
						console.log('面单地址', res.data)
						let flagId = false
						res.data.forEach(p => {
							if (p.error) {
								flagId = true
							}
							p.hasPrined = false
							p.time = utils.renderTimeDate(p.createTime)
							p.orders = JSON.parse(p.ordersn)
							p.urlCopy = JSON.parse(p.url)
							p.name = p.logistics + "_" + p.time + "_" + p.orders.length
						})

						if (flagId) {
							this.$message.warning(this.$t('other.a1054'))
							return
						}
						this.printedUrl = res.data
						this.printedvisabable = true
					} else {
						this.message.warning(res.msg)
					}
				})
		},

		//临时默认打印面单
		printFastOrderCopy() {
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a1008'))
				return
			}
			let arr = []
			let flag = false
			this.multipleSelection.forEach((p, index) => {
				arr.push(p.orderId)
				if (!p.orderPdf) {
					flag = true
				}
			})
			if (flag) {
				this.$message.warning(this.$t('other.a1055'))
				return
			}
			localStorage.setItem('unprocessedOrderIds', JSON.stringify(arr))
			let routeData2 = this.$router.resolve({
				name: "productAndPicklistCopy",
			})
			window.open(routeData2.href, '_blank');
			this.$confirm(this.$t('other.a1009'), this.$t("other.a142"), {
				confirmButtonText: this.$t('other.a1010'),
				cancelButtonText: this.$t('other.a146'),
				type: 'warning'
			}).then(() => {
				this.refleshPage()
			})


		},

		checkOrderStatus() {
			let flag = false
			this.multipleSelection.forEach(p => {
				if (!p.trackingNo || !p.ready || !p.sent) {
					flag = true
				}
			})

			return flag
		},

		//单次打印面单
		prinWaybill() {

			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a1008'))
				return
			}

			// let falg = this.checkOrderStatus()
			// if (falg) {
			// 	this.$message.warning(this.$t('other.a1056'))
			// 	return
			// }

			let arr = this.multipleSelection.map((p, index) => {
				return p.orderId
			})
			localStorage.setItem('unprocessedOrderIds', JSON.stringify(arr))



			let routeData2 = this.$router.resolve({
				name: "productWaybill",
			})
			window.open(routeData2.href, '_blank');
			this.$confirm(this.$t('other.a1009'), this.$t("other.a142"), {
				confirmButtonText: this.$t('other.a1010'),
				cancelButtonText: this.$t('other.a146'),
				type: 'warning'
			}).then(() => {
				this.refleshPage()
			})


			},

		//快速打印面单+拣货单
		printFastOrder() {

			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a1008'))
				return
			}

			let falg = this.checkOrderStatus()
			// if (falg) {
			// 	this.$message.warning(this.$t('other.a1056'))
			// 	return
			// }

			let arr = this.multipleSelection.map((p, index) => {
				return p.orderId
			})
			localStorage.setItem('unprocessedOrderIds', JSON.stringify(arr))

			this.addPrintNum(arr);

			let routeData2 = this.$router.resolve({
				name: "productAndPicklist",
			})
			window.open(routeData2.href, '_blank');
			this.$confirm(this.$t('other.a1009'), this.$t("other.a142"), {
				confirmButtonText: this.$t('other.a1010'),
				cancelButtonText: this.$t('other.a146'),
				type: 'warning'
			}).then(() => {
				this.refleshPage()
				
			})


		},

		continuePrint() {
			let arrList = [null, null]
			this.list.forEach(p => {
				if (p.defaultFrom) {
					arrList[0] = p
				} else if (p.defaultReceive) {
					arrList[1] = p
				}
			})

			console.log('arrList', arrList)

			if (!arrList[0]) {
				this.$message.warning(this.$t('other.a1057'))
				return
			} else if (!arrList[1]) {
				this.$message.warning(this.$t('other.a1058'))
				return
			}

			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a1008'))
				return
			}

			let arr = this.multipleSelection.map((p, index) => {
				p.ADselfOrder = arrList
				return p.orderId
			})

			localStorage.setItem('unprocessedOrderIds', JSON.stringify(arr))
			let routeData2 = this.$router.resolve({
				name: "selfbuiltorder",
			})
			window.open(routeData2.href, '_blank')
		},

		selfBuiltOrder() {

			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a1008'))
				return
			}

			let arr = this.multipleSelection.map((p, index) => {
				return p.orderId
			})


			localStorage.setItem('unprocessedOrderIds', JSON.stringify(arr))



			let routeData2 = this.$router.resolve({
				name: "selfbuiltorder",
			})
			window.open(routeData2.href, '_blank');





		},
		// 越南专用

		ignkfb() {
			let arr = []
			this.multipleSelection.forEach((p, index) => {
				arr.push(p.orderId)
			})


			localStorage.setItem('unprocessedOrderIds', JSON.stringify(arr))



			let routeData2 = null
			routeData2 = this.$router.resolve({
				name: "vnprintPage",
			})


			window.open(routeData2.href, '_blank')
		},
		downloadAll() {
			let arr = []
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a716'))
				return
			}
			this.loading = this.$loading({
				lock: true,
				text: '下载中！',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			for (let i = 0; i < this.multipleSelection.length; i++) {
				if (this.multipleSelection[i].orderPdf && this.multipleSelection[i].orderPdf.pdf) {
					arr.push(this.multipleSelection[i].orderPdf.pdf);
				}
			}
			console.log(111)
			let fileName = `${arr.length} ${utils.renderTime(new Date().getTime())}.zip`
			this.downloadPdfAsZip(arr, fileName)
		},
		async downloadPdfAsZip(pdfUrls, zipName) {
			console.log(pdfUrls)
			const zip = new JSZip();
			const promises = pdfUrls.map(url =>
				axios.get(url, { responseType: 'blob' }).then(res => {
					const fileName = url.split('/').pop();
					zip.file(fileName, res.data);
				})
			);
			await Promise.all(promises);
			const content = await zip.generateAsync({ type: 'blob' });
			saveAs(content, zipName);
			this.loading.close();
			this.$refs.multipleTable.clearSelection();
			this.$message.success('成功！');
			newOrders
				.addPrintNum(pdfUrls)
				.then(res => {
					if (res.code === 200) {
						console.log('增加了打印次数！')
					} else {
						console.log('增加了打印次数！', res.msg)
					}
				})
		},
		downloadPrint(index,items,FItem) {
			console.log(items,'===items')
			let arr = []
			let num = 0;
			if(this.downloadShow){
				this.$message.warning(this.$t('other.a3420'))
				return
			}
			if(index == 2){
				console.log(FItem)
					let status = items.length>1?true:false
					num = 1;
					for (let j = 0; j < items.length; j++) {
						console.log(items[j])
						if((items[j].pintImage&&items[j].pintImage!='')||items[j].standardPattern){
							let item = items[j]
							let pImg = item.pintImage?item.pintImage:item.standardPattern.standardPatternPrintImagesList[0].imageUrl
							// item.image = item.image.replace("https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com", "/ddxapi")
							// item.pintImage = item.pintImage.replace("https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com", "/ddxapi")
							arr.push({
								orderId:item.orderId,
								orderText:status?item.orderId+'-'+(j+1)+'（Total '+items.length+' Pcs）':item.orderId,
								fileName:(status?item.orderId+'-'+(j+1)+'（Total '+items.length+' Pcs）':item.orderId)+'.'+pImg.substring(pImg.lastIndexOf(".") + 1),
								image:item.attributeImage ? item.attributeImage : item.image,
								pintImage:pImg,
								itemSku:item.itemSku,
								variationSku:FItem.distributeGoods?item.storeItem.children[0].skuName: item.storeItem.skuName,
								pdfImagePath:FItem.orderPdf?FItem.orderPdf.pdf:null,
								variationQuantityPurchased:item.variationQuantityPurchased
							})
						}
					}
			}else if(!this.multipleSelection.length&&index == 1){
				this.$message.warning(this.$t('other.a152'))
				return
			}else if(this.multipleSelection.length&&index == 1){
				let numIndex = 0;
				console.log(this.multipleSelection,'===>this.multipleSelection')
				for (let i = 0; i < this.multipleSelection.length; i++) {
					num += 1;
						let status = this.multipleSelection[i].items.length>1?true:false
				console.log(this.multipleSelection[i],'===>this.multipleSelection[i]')
					for (let j = 0; j < this.multipleSelection[i].items.length; j++) {
						console.log(this.multipleSelection[i].items[j])
						// numIndex = this.multipleSelection[i].items[j].find(item=>item.pintImage)?numIndex+1:numIndex;
						if((this.multipleSelection[i].items[j].pintImage&&this.multipleSelection[i].items[j].pintImage!='')||this.multipleSelection[i].items[j].standardPattern){
							let item = this.multipleSelection[i].items[j]
							let pImg = item.pintImage?item.pintImage:item.standardPattern.standardPatternPrintImagesList[0].imageUrl
							// console.log(item.pintImage.substring(item.pintImage.lastIndexOf(".") + 1))
							// item.image = item.image.replace("https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com", "/ddxapi")
							// item.pintImage = item.pintImage.replace("https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com", "/ddxapi")
							// pImg = pImg.replace("https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com", "/ddxapi")
							arr.push({
								orderId:item.orderId,
								orderText:status?item.orderId+'-'+(j+1)+'（Total '+this.multipleSelection[i].items.length+' Pcs）':item.orderId,
								fileName:(status?item.orderId+'-'+(j+1)+'（Total '+this.multipleSelection[i].items.length+' Pcs）':item.orderId)+'.'+pImg.substring(pImg.lastIndexOf(".") + 1),
								image:item.attributeImage ? item.attributeImage : item.image,
								pintImage:pImg,
								itemSku:item.itemSku,
								variationSku: this.multipleSelection[i].distributeGoods?item.storeItem.children[0].skuName:item.storeItem.skuName,
								pdfImagePath:this.multipleSelection[i].orderPdf?this.multipleSelection[i].orderPdf.pdf:null,
								variationQuantityPurchased:item.variationQuantityPurchased
							})
						}
					}
				}
			}
			if(arr.length == 0){
				this.$message.warning(this.$t('other.a3421'))
				return
			}
			console.log(arr)
			let arrData = []
			let arrOrderId = []
			for(let i = 0;i<arr.length;i++){
				arrData.push({
					"orderId":arr[i].orderId,
					"orderNo":arr[i].orderText,
					"pintImagePath": arr[i].pintImage, 
					"skuName": arr[i].variationSku, 
					"imagePath": arr[i].image, 
					"pdfImagePath":  arr[i].pdfImagePath,
					"variationQuantityPurchased":arr[i].variationQuantityPurchased
				})
				
				if(arrOrderId.indexOf(arr[i].orderId)==-1){
					arrOrderId.push(arr[i].orderId)
				}
			}
			console.log(arrData)
			console.log(arrOrderId)
			// return
			// return
			// arrData =[
			// {
			// 	"pintImagePath": "https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/1017dc129405418989652a9f86d99d2f.png",
			// 	"skuName": "SKU-20260530-002",
			// 	"imagePath": "https://img.kwcdn.com/thumbnail/s/1abb02a973ac44dc1bdc5c7e5c23bb58_d4d595906cfe.jpg",
			// 	"pdfImagePath": "https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/pdf/PO-211-13020703473270695.pdf"
			// } , 
			// ]
			
			this.downloadShow = true;

			orders.batchDownloadPrintDrawings(arrData).then(res=>{
				console.log(res.data,'res.data')
				if(res.code == 200){
					this.addPrintNum(arrOrderId)
					this.downloadShow = false
					this.$message.success('成功！')
					this.$refs.multipleTable.clearSelection();
					const url = res.data.downloadUrl
					const a = document.createElement('a')
					a.href = url
					// a.download = fileName
					document.body.appendChild(a)
					a.click()
					// 释放资源
					document.body.removeChild(a)
					window.URL.revokeObjectURL(url)
					setTimeout(() => {
									this.init()
									this.getNotHandlePages()
								},500)
				}else{
					this.downloadShow = false
					this.$message.error('失败！')
				}
			})

			// return
			// axios.post('https://erp.shopsbu.com/service/shopOrder/batchDownloadPrintDrawings', arrData, {
			// 	responseType: 'blob' // 关键配置：告诉axios这是二进制文件流
			// })
			// .then(res => {
			// 	console.log('请求成功，准备下载文件', res.data)
				
			// 	this.$message.success('成功！')
			// 	this.downloadShow = false
			// 	this.$refs.multipleTable.clearSelection();
			// 	// 1. 从响应头里获取文件名（如果后端返回了）
			// 	const contentDisposition = res.headers['content-disposition']
			// 	// let fileName = '打印文件.zip' // 默认文件名
			// 	let fileName = `${num} ${utils.renderTime(new Date().getTime())}.zip`
			// 	if (contentDisposition) {
			// 		const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
			// 		if (match != null && match[1]) {
			// 			fileName = decodeURIComponent(match[1].replace(/['"]/g, ''))
			// 		}
			// 	}

			// 	// 2. 创建Blob对象并触发下载
			// 	const blob = new Blob([res.data], { type: res.headers['content-type'] || 'application/octet-stream' })
			// 	const url = window.URL.createObjectURL(blob)
			// 	const a = document.createElement('a')
			// 	a.href = url
			// 	a.download = fileName
			// 	document.body.appendChild(a)
			// 	a.click()
			// 	// 释放资源
			// 	document.body.removeChild(a)
			// 	window.URL.revokeObjectURL(url)
			// })
			// .catch(err => {
			// 	console.error('请求失败', err)
			// 	this.downloadShow = false
			// 	this.$message.error('失败！')
			// 	// 额外：处理后端返回的错误信息（可能是JSON格式的错误）
			// 	if (err.response && err.response.data instanceof Blob) {
			// 		const reader = new FileReader()
			// 		reader.onload = function() {
			// 			try {
			// 				const errorJson = JSON.parse(reader.result)
			// 				console.error('接口返回错误', errorJson)
			// 			} catch (e) {
			// 				console.error('无法解析错误信息', reader.result)
			// 			}
			// 		}
			// 		reader.readAsText(err.response.data)
			// 	}
			// })		
			// return
  			// window.addEventListener('wheel', this.preventScroll, { passive: false });
			
			// this.downloadData = arr;
			// this.downloadIndex = 0;
			// this.downloadArrIndex = 0;
			// this.downloadArr = [];
			// this.downloadpercentage = 0;
			// this.generate()
			// this.downloadImages(num);
		},

		async downloadImages(num) {
			const loading = this.$loading({
				lock: true,
				text: '图片下载中！',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			try {
				this.downloadpercentage = 0;
				
				const zip = new JSZip();
        		const promises = [];
       	 		const progressStep = 100 / this.downloadData.length;

				this.downloadData.forEach((item, index) => {
				const promise = axios.get(item.pintImage, {
					responseType: 'arraybuffer',
					onDownloadProgress: () => {
              			this.downloadpercentage += progressStep / 2;
					}
				}).then(response => {
					const fileName = item.fileName;
					zip.file(fileName, response.data, { binary: true });
					this.downloadpercentage += progressStep / 2;
					return response;
				});
				
				promises.push(promise);
				});

				await Promise.all(promises);
				
				const content = await zip.generateAsync({ type: 'blob' }, meta => {
				//  console.log(meta,'===>meta')
				 this.downloadpercentage = meta.percent;
				});
				let fileName = `${num}-${this.downloadData.length} ${utils.renderTime(new Date().getTime())}.zip`
				saveAs(content, fileName);
			} catch (error) {
				console.error('下载失败:', error);
				this.$emit('error', error);
			} finally {
				this.$refs.multipleTable.clearSelection();
				this.$message.success('成功！')
				this.downloadShow = false;
				this.downloadData = [];
				this.downloadIndex = 0;
				this.downloadArr = [];
				this.downloadArrIndex = 0;
				this.downloadpercentage = 0;
				loading.close();
			}
		},
		async generate() {
			if (this.downloadIndex >= this.downloadData.length) {
				this.$refs.multipleTable.clearSelection();
				this.$message.success('成功！')
				this.downloadShow = false;
				this.downloadData = [];
				this.downloadIndex = 0;
				this.downloadArr = [];
				this.downloadArrIndex = 0;
				return
			};
			let item = this.downloadData[this.downloadIndex]
			console.log(item,'==>item')
			const canvas = this.$refs.canvasImg
			const ctx = canvas.getContext('2d')
			

			// 加载所有图片
			const baseImg = await this.loadImage(item.pintImage)

			const [topImg, qrCode] = await Promise.all([
				this.loadImage(item.image),
				this.generateQRCode(item.orderId,baseImg.height/10)
			])
			// console.log(baseImg,'==>baseImg')
			// console.log(topImg,'==>topImg')
			// console.log(qrCode,'==>qrCode')
			// 设置canvas尺寸与底图相同
			canvas.width = baseImg.width
			canvas.height = baseImg.height + baseImg.height/10 + 40

			// 绘制底图
			ctx.fillStyle = "#fff";
			ctx.fillRect(0, 0, canvas.width, canvas.height);
			ctx.drawImage(baseImg, 0, baseImg.height/10 + 40, canvas.width, canvas.height)
			
			// 计算顶部区域位置（顶部图片和二维码并排）
			const topAreaHeight = Math.max(baseImg.height/10, baseImg.height/10) // 200是二维码高度
			const topAreaY = 20 // 距离顶部20px
			
			// 绘制二维码（左）
			const qrX = 20
			ctx.drawImage(qrCode, qrX, topAreaY, baseImg.height/10, baseImg.height/10)

			// 绘制顶部图片（右）
			const topImgX = baseImg.height/10 + 20
			ctx.drawImage(topImg, topImgX, topAreaY, baseImg.height/10, baseImg.height/10)

			//绘制文字
			let a = baseImg.height/10/6+'px Arial'
			let aT = item.orderText+'；'+item.itemSku+'；'+item.variationSku
			console.log(a)
			ctx.font = a
			ctx.fillStyle = "#333";
			ctx.fillText(aT, baseImg.height/10+baseImg.height/10+40, baseImg.height/10/2); // 在(10, 50)位置绘制文字
			
			// 下载图片
			const link = document.createElement('a')
			link.download = item.orderText+'.png'
			link.href = canvas.toDataURL('image/png')
			link.click()


			// 清除画布
			ctx.clearRect(0, 0, canvas.width, canvas.height);

			// 延迟后绘制下一个
			this.downloadIndex++;
			setTimeout(this.generate, 1000);
		},
		loadImage(src) {
			console.log(src,'===>src')
			return new Promise((resolve) => {
				const img = new Image()
				img.crossOrigin = 'Anonymous'
				img.onload = () => resolve(img)
				img.src = src
			})
		},
		generateQRCode(text,wh) {
			console.log(wh)
			return new Promise((resolve) => {
				const canvas = document.createElement('canvas')
				QRCode.toCanvas(canvas, text, { width: wh }, (error) => {
				if (error) console.error(error)
				resolve(canvas)
				})
			})
		},
		//触发打印面单前，检测是否含有已打印过的订单，或者是未生成运单号的订疸
		//返回值：1：已打印订单，2:未生成运单号，3：可以打印
		checkOrderTypePICKMerge() {
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a1008'))
				return
			}
			let list = this.multipleSelection
			let num = this.multipleSelection.length
			let arr1 = []//已打印订单
			let arr2 = []//未生成运单号订单
			list.forEach(p => {
				if (p.printNum > 0) {
					arr1.push(p)
				} else if (p.trackingNo == '' || !p.orderPdf) {
					arr2.push(p)
				}
			})

			// if(arr2.length > 0 ){
			// 	let Systemtext=this.$t('other.a1059')+num+this.$t('other.a1060')+arr2.length+this.$t('other.a1061')
			// 	this.$confirm(Systemtext, this.$t("other.a142"), {
			// 	confirmButtonText: this.$t("other.a884"),
			// 	cancelButtonText: this.$t('other.a146'),
			// 	type: 'warning'
			// 	}).then(() => {})
			// 	return
			// }

			// if(arr1.length > 0 ){
			// 	this.Systemtext=this.$t('other.a1059')+num+this.$t('other.a1062')+arr1.length+this.$t('other.a1063')
			// 	this.systemDia=true
			// 	return
			// }

			let arr = []
			this.multipleSelection.map((p, index) => {
				arr.push(p.orderId)
			})

			localStorage.setItem('unprocessedOrderIds', JSON.stringify(arr))
			let routeData2 = null
			if (this.userId == 'ST1kevin985517@gmail.com') {
				routeData2 = this.$router.resolve({
					name: "sellertest",
				})
			} else {
				routeData2 = this.$router.resolve({
					name: "productPickSheetMerge",
				})
			}
			window.open(routeData2.href, '_blank')
		},
		checkOrderTypePICK() {
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a1008'))
				return
			}
			let list = this.multipleSelection
			let num = this.multipleSelection.length
			let arr1 = []//已打印订单
			let arr2 = []//未生成运单号订单
			list.forEach(p => {
				if (p.printNum > 0) {
					arr1.push(p)
				} else if (p.trackingNo == '' || !p.orderPdf) {
					arr2.push(p)
				}
			})

			// if(arr2.length > 0 ){
			// 	let Systemtext=this.$t('other.a1059')+num+this.$t('other.a1060')+arr2.length+this.$t('other.a1061')
			// 	this.$confirm(Systemtext, this.$t("other.a142"), {
			// 	confirmButtonText: this.$t("other.a884"),
			// 	cancelButtonText: this.$t('other.a146'),
			// 	type: 'warning'
			// 	}).then(() => {})
			// 	return
			// }

			// if(arr1.length > 0 ){
			// 	this.Systemtext=this.$t('other.a1059')+num+this.$t('other.a1062')+arr1.length+this.$t('other.a1063')
			// 	this.systemDia=true
			// 	return
			// }

			let arr = []
			this.multipleSelection.map((p, index) => {
				arr.push(p.orderId)
			})

			localStorage.setItem('unprocessedOrderIds', JSON.stringify(arr))
			let routeData2 = null
			if (this.userId == 'ST1kevin985517@gmail.com') {
				routeData2 = this.$router.resolve({
					name: "sellertest",
				})
			} else {
				routeData2 = this.$router.resolve({
					name: "productPickSheet",
				})
			}
			window.open(routeData2.href, '_blank')
		},
		checkOrderType() {
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a1008'))
				return
			}
			let list = this.multipleSelection
			let num = this.multipleSelection.length
			let arr1 = []//已打印订单
			let arr2 = []//未生成运单号订单
			list.forEach(p => {
				if (p.printNum > 0) {
					arr1.push(p)
				} else if (p.trackingNo == '' || !p.orderPdf) {
					arr2.push(p)
				}
			})

			if (arr2.length > 0) {
				let Systemtext = this.$t('other.a1059') + num + this.$t('other.a1060') + arr2.length + this.$t('other.a1061')
				this.$confirm(Systemtext, this.$t("other.a142"), {
					confirmButtonText: this.$t("other.a884"),
					cancelButtonText: this.$t('other.a146'),
					type: 'warning'
				}).then(() => { })
				return
			}

			if (arr1.length > 0) {
				this.Systemtext = this.$t('other.a1059') + num + this.$t('other.a1062') + arr1.length + this.$t('other.a1063')
				this.systemDia = true
				return
			}

			let arr = []
			this.multipleSelection.map((p, index) => {
				arr.push(p.orderId)
			})

			localStorage.setItem('unprocessedOrderIds', JSON.stringify(arr))
			let routeData2 = null
			if (this.userId == 'ST1kevin985517@gmail.com') {
				routeData2 = this.$router.resolve({
					name: "sellertest",
				})
			} else {
				routeData2 = this.$router.resolve({
					name: "productExpressSheet",
				})
			}
			window.open(routeData2.href, '_blank')
		},

		printFastOrderSH(num) {
			let arr = []
			this.multipleSelection.map((p, index) => {
				if (num == 0) {
					arr.push(p.orderId)
				} else if (num == 1 && p.printNum == 0) {
					arr.push(p.orderId)
				}

			})

			console.log('arr', arr)

			localStorage.setItem('unprocessedOrderIds', JSON.stringify(arr))



			let routeData2 = null
			if (this.userId == 'ST1kevin985517@gmail.com') {
				routeData2 = this.$router.resolve({
					name: "sellertest",
				})
			} else {
				routeData2 = this.$router.resolve({
					name: "productExpressSheet",
				})
			}


			window.open(routeData2.href, '_blank')

		},
		printFastOrderLA() {
			let params = {
				// cacheData:JSON.stringify(this.formLabelAlign),
				cacheKey: this.userId + '_' + 'Shipper_Address',
				userId: this.userId
			}
			api
				.getUserCache(params)
				.then(res => {

					if (res.code === 200) {

						if (res.data) {
							this.formLabelAlign = JSON.parse(res.data.cacheData)
							let routeData2 = this.$router.resolve({
								name: "productLazada",
							})
							window.open(routeData2.href, '_blank');
						} else {
							this.$message.warning(this.$t('other.a992'))

							setTimeout(() => {
								this.information = true;
							}, 1000);
						}

					} else {
						this.$message.warning(res.msg)
					}
				})
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a1008'))
				return
			}

			let arr = this.multipleSelection.map((p, index) => {
				return p.orderId
			})
			localStorage.setItem('unprocessedOrderIds', JSON.stringify(arr))




		},


		handleBtn(key, index, indexTwo) {
			this.activeBtnIndex = [key, index, indexTwo]
			console.log(key, index, indexTwo)
			let list = JSON.parse(JSON.stringify(this.activeIndex))
			list[index] = indexTwo
			this.activeIndex = []
			for (let i = 0; i < list.length; i++) {
				if (i > index) {
					list[i] = 0
				}
				this.activeIndex.push(list[i])
			}


			let orderlist = this.mapList[index].get(key)


			this.orderClassification(orderlist, index)
			console.log('orderlist', orderlist)


		},

		viewError() {
			console.log('failErrorOrder', this.failErrorOrder)
			this.viewFaileDetail = true
		},

		ignk() {
			this.isNotify = false
			showLoading()
			setTimeout(() => {
				this.init()
				this.getNotHandlePages()

			}, 800)
		},

		init() {
			this.activeIndex = []
			for (let i = 0; i < 14; i++) {
				this.activeIndex.push(0)
			}
			this.multipleSelection = []
			this.hasData = false

			this.getDataParams.end = null
			this.getDataParams.start = null
			this.getDataParams.hasStoreItem = true
			this.getDataParams.hasPdf = true
			this.getDataParams.offset = null
			this.getDataParams.page = 0
			this.getDataParams.orderId = null
			this.getDataParams.platform = null
			this.getDataParams.sellerUserId = null
			this.getDataParams.shopIds = this.allshopIds
			this.getDataParams.storeIds = this.allstoreIds
			this.getDataParams.sortType = 0
			this.getDataParams.userId = this.userId
			this.activeBtnIndex = []
			this.mapList = []
			this.successTotal = 0
		},

		//获取待处理的订单数据
		getNotHandlePages() {
			newOrdersApi
				.queryPendingOrders(this.getDataParams)
				.then(res => {
					if (res.code === 200) {
						this.hasData = true
						res.data.forEach(p => {
							console.log(p.orderId)
							// if (p.orderId == 'PO-211-02459703777913370') {
							// 	console.log(p)
							// 	console.log('===1111')
							// }
							p.flagColor = p.msgToStore ? 99999 : p.flagColor
							p.distributeStatus = p.distributeStatus == null ? 0 : p.distributeStatus
							p.canAudit = JudegeBindStore(p.items)
							p.country = p.country.toUpperCase()
							p.items.length > 1 ? p.onesku = false : p.onesku = true
							p.loadingType = p.sent ? p.ready ? 2 : 1 : 0
							p.items.printNum == 0 ? p.printed = false : p.printed = true
							p.shipByDate = utils.renderTimeDate(p.shipByDate)
							p.flagId = p.flagId == null ? 0 : p.flagId
							p.auditTime = p.auditTime == null ? p.auditTime : utils.renderTime(p.auditTime)
							p.createTime = p.createTime == null ? p.createTime : utils.renderTime(p.createTime)
							p.packagedTime = p.packagedTime == null ? p.packagedTime : utils.renderTime(p.packagedTime)
							p.printTime = p.printTime == null ? p.printTime : utils.renderTime(p.printTime)
							p.checkTime = p.checkTime == null ? p.checkTime : utils.renderTime(p.checkTime)
							p.payTime = p.payTime == null ? p.payTime : utils.renderTime(p.payTime)
							p.unger = p.other == null ? false : true
							p.itemNum = p.items.length
							p.distributeGoods = p.distributeStatus == 0 ? false : true
							p.sensitive = p.canAudit == 0 ? JudegeSensitive(p.items) : false
							p.beforeTen = new Date(p.auditTime) - new Date(this.currenTenoclock) < 0 ? true : false
							p.itemAmount = 0
							p.printed = p.printNum == 0 && p.printTime == null ? false : true
							p.notWorth = false
							p.items.forEach(k => {
								if (k.storeItem) {
									if (k.storeItem.storeNum < k.variationQuantityPurchased) {
										p.notWorth = true
									}
								}
								p.itemAmount += k.variationQuantityPurchased
							})
						})
						res.data.sort((a, b) => {
							return new Date(b.auditTime) - new Date(a.auditTime)
						})

						for (let i = 0; i < 17; i++) {
							this.activeIndex.push(0)
							this.mapList.push(new Map())
							this.mapList[i].set('all', res.data)
							if (i == 1 || i == 4 || i == 6 || i == 10 || i == 11 || i == 12 || i == 13 || i == 14 || i == 15 || i == 16) {
								this.mapList[i].set(true, [])
								this.mapList[i].set(false, [])
							}
						}
						this.mapList[0].set('SHOPEE', [])
						this.mapList[0].set('LAZADA', [])
						// this.mapList[0].set(this.$t('other.a1004'),[])

						let listMap = new Map()
						res.data.forEach(p => {
							listMap.set(p.platform, this.getMap(this.mapList[0], p.platform, p))
						})
						console.log('listmap', listMap)
						console.log('获取待处理的订单', res.data)
						this.totalList = res.data.length


						this.orderClassification(res.data, -1)
						this.orderClassification(listMap.get('SHOPEE'), 0)

					} else {
						this.message.warning(res.msg)
					}
				})
		},

		//将获取到待单进行分类
		orderClassification(list, num) {
			let orderlist = JSON.parse(JSON.stringify(list))
			this.btnlist = []

			this.mapList.forEach((key, i) => {
				if (i > num) {
					for (let [ky] of key) {
						key.set(ky, [])
					}
				}

			})

			orderlist.forEach((p, index) => {
				if (num < 0) {
					this.mapList[0].set(p.platform, this.getMap(this.mapList[0], p.platform, p))
				}

				if (num < 1) {
					this.mapList[1].set(p.sensitive, this.getMap(this.mapList[1], p.sensitive, p))
				}


				if (num < 2) {
					this.mapList[2].set(p.userId, this.getMap(this.mapList[2], p.userId, p))
				}

				if (num < 3) {
					this.mapList[3].set(p.shopId, this.getMap(this.mapList[3], p.shopId, p))
				}
				if (num < 4) {
					this.mapList[4].set(p.distributeGoods, this.getMap(this.mapList[4], p.distributeGoods, p))
				}
				// 加载状态 0：未生成 1：加载中 2：已加载 
				if (num < 5) {
					let list = this.mapList[5].get(p.loadingType)
					if (list == null || list == undefined) {
						list = []
					}
					list.push(p)
					this.mapList[5].set(p.loadingType, list)
				}
				if (num < 6) {
					this.mapList[6].set(p.printed, this.getMap(this.mapList[6], p.printed, p))
				}
				if (num < 7) {
					this.mapList[7].set(p.logistics, this.getMap(this.mapList[7], p.logistics, p))
				}
				if (num < 8) {
					this.mapList[8].set(p.flagColor, this.getMap(this.mapList[8], p.flagColor, p))
				}
				if (num < 9) {
					this.mapList[9].set(p.shipByDate, this.getMap(this.mapList[9], p.shipByDate, p))
				}
				if (num < 10) {
					this.mapList[10].set(p.unger, this.getMap(this.mapList[10], p.unger, p))
				}
				if (num < 11) {
					this.mapList[11].set(p.packaged, this.getMap(this.mapList[11], p.packaged, p))
				}
				if (num < 12) {
					this.mapList[12].set(p.onesku, this.getMap(this.mapList[12], p.onesku, p))
				}
				if (num < 13) {//是否缺货
					this.mapList[13].set(p.notWorth, this.getMap(this.mapList[13], p.notWorth, p))
				}

				if (num < 14) {//当天十点前
					this.mapList[14].set(p.beforeTen, this.getMap(this.mapList[14], p.beforeTen, p))
				}

				if (num < 15) {//是否空包
					this.mapList[15].set(p.emptyOrder, this.getMap(this.mapList[15], p.emptyOrder, p))
				}
				
				if (num < 16) {//是否有图
					if(p.items.find(item=>item.pintImage||item.standardPattern)){
						let list = this.mapList[16].get(true)
						list.push(p)
						this.mapList[16].set(true, list)
					}else{
						let list = this.mapList[16].get(false)
						list.push(p)
						this.mapList[16].set(false, list)
					}
				}
			})

			for (let i = 0; i < 17; i++) {
				if (i > num) {
					this.mapList[i].set('all', list)
				}
			}
			const title = {
				0: this.$t('storePending').Form,
				1: this.$t('other.a775'),
				2: this.$t('storePending').UserName,
				3: '店铺选择',
				4: this.$t('other.a777'),
				5: this.$t('storePending').Loading_status,
				6: this.$t('storePending').Printstatus,
				7: this.$t('storePending').LogisticsType,
				8: this.$t('storePending').orderMakr,
				9: this.$t('storePending').lastDeliveryTime,
				10: this.$t('homeTwo').urgent,
				11: this.$t('storePending').exwarehouse,
				12: this.$t('storePending').orderInclude,
				13: this.$t('storePending').Inventory,
				14: this.$t('storePending').pushTime,
				15: this.$t('storePending').specialOrder,
				16: '是否有图',
			}



			this.mapList.forEach((key, i) => {
				let list = []
				key.forEach((item, value) => {
					list.push({
						key: value,
						value: item
					})
				})
				this.btnlist.push({
					desc: title[i],
					option: list
				})
			})


			if (this.activeIndex[10] == 0) {
				this.target = 'all'
			}
			if (this.activeIndex[10] == 1) {
				this.target = true
			}
			if (this.activeIndex[10] == 2) {
				this.target = false
			}

			this.btnlist.forEach((p, index) => {
				if (index == 9) {
					p.option.forEach(k => {
						let ttp = new Date(k.key)
						k.num = ttp.valueOf()
					})
				} else if (index == 2) {
					p.option.forEach(k => {
						let arr = k.key.split('').join('')
						k.num = arr.slice(k.key.length - 2)
						k.num = Number(k.num) ? Number(k.num) : 0
					})
				}
			})

			// this.btnlist[7].option.forEach((p) => {

			// })

			this.btnlist[9].option.sort((a, b) => {
				return a.num - b.num
			})

			this.btnlist[3].option.sort((a, b) => {
				return a.num - b.num
			})

			this.btnlist[0].option.splice(0, 1)
			this.btnlist[10].option.splice(this.btnlist[10].option.length - 1, 1)
			this.btnlist[15].option.splice(0, 1)
			this.btnlist[9].option.forEach((p, index) => {
				if (!p.key) {
					this.btnlist[9].option.splice(index, 1)
				}
			})
			let sourceIndex
			this.btnlist[15].option[0] = this.btnlist[15].option.splice(1, 1, this.btnlist[15].option[0])[0];



			console.log('btnlist', this.btnlist)
			console.log('activeIndex', this.activeIndex)
			console.log('mapList', this.mapList)


		},

		getMap(mapList, key, p) {
			let list = mapList.get(key)
			if (list == null || list == undefined) {
				list = []
			}
			list.push(p)
			return list

		},


		getTime(time) {
			return utils.renderTime(time)
		},

		handleSelectionChange(val) {
			this.multipleSelection = val;
			console.log('multipleSelection', this.multipleSelection)
		},

		//控制每页显示订单条数
		handleSizeChange(val) {
			console.log(`${val}`);
			this.offset = parseInt(`${val}`)
		},
		//显示当前第几页
		handleCurrentChange(val) {
			console.log(`${val}`)
			if (`${val}` == 'undefined') {
				this.currentPage = 1
				this.page = 1
			} else {
				this.currentPage = parseInt(`${val}`)
				this.page = parseInt(`${val}`)
			}
		},







	}
}
</script>

<style lang="scss" scoped>
.storePendingorder {
	position: relative;
	background: #fff;

	.ioingn {
		display: inline-block;
		margin: 0 10px 10px 10px;
		cursor: pointer;
	}

	.pking {
		color: red;
		display: inline-block;
		margin: 0 10px 10px 10px;
		cursor: pointer;
	}

	.oegvjh {
		color: #409EFF;
		display: inline-block;
		margin: 0 10px 10px 10px;
		cursor: pointer;
	}

	.viewMore {
		display: inline-block;
		cursor: pointer;
		font-size: 12px;
		background-color: #409EFF;
		border: 1px solid #eee;
		padding: 5px 10px;
		border-radius: 3px;
		margin-left: 15px;
		color: #fff;
	}

	.sensitive {
		color: #fff;
		background-color: rgb(244, 140, 24);
		box-sizing: border-box;
		padding: 2px 8px;
		border-radius: 3px;
	}

	.distributeGoods {
		color: #fff;
		background-color: #67C23A;
		box-sizing: border-box;
		padding: 2px 8px;
		border-radius: 3px;
	}

	.title {
		font-size: 18px;

	}

	.top_box {
		text-align: center;
		font-size: 18px;
		font-weight: bold;
	}

	.icon-jinggao1 {
		color: red;
		font-size: 22px;
		margin-right: 10px;
	}

	.kvhfk {
		color: red;
		font-weight: 500;
	}

	.notify-boxw {
		width: 330px;
		height: 199px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		position: fixed;
		top: 150px;
		right: 30px;
		border-radius: 8px;
		box-sizing: border-box;
		padding: 10px;
		z-index: 999999;
		background: #ffff;
	}

	.el-icon-loading:before {
		content: "\E6CF";
		font-size: 20px;
	}


	.search_wraper {
		display: flex;
		margin: 10px 0;

		.search_item {
			display: flex;
			margin-right: 20px;
			align-items: center;

			.item_desc {
				display: inline-block;
				width: 120px;
			}
		}

	}

	/deep/ .el-step__title {
		color: #000;
		font-weight: bold;
	}

	/deep/ .el-step__description {
		color: #000;
	}

	.step {
		width: 100%;
		box-sizing: border-box;
		padding: 0 15px;
	}

	.checkallbox {
		cursor: pointer;
		padding-bottom: 20px;

	}

	.operation_area {
		display: flex;

		.opeartion_btn {
			margin-right: 10px;
		}

	}

	.Pager {
		position: fixed;
		bottom: 0;
		width: 100%;
		height: 45px;
		background-color: #FFFFFF;
		z-index: 99;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		box-sizing: border-box;
		padding-right: 220px;
	}

	.btn_box {
		font-size: 14px;
		margin-top: 15px;

		.btn_item {
			display: inline-block;
			box-sizing: border-box;
			padding: 4px 8px;
			border: 1px solid #d9d9d9;
			margin-right: 5px;
			margin-bottom: 5px;
			cursor: pointer;



		}

		.btn_desc {
			margin-right: 15px;
			min-width: 65px;
		}

		.btn_item_active {
			background-color: #1890ff;
			color: #fff;
		}

		// .btn_outer{
		// 	padding:5px 0 10px 0;

		// }
	}

	.order_box {
		margin: 0 15px 60px 0;


		.order_time {
			font-size: 10px;
		}


		.content_wrapper {
			display: flex;
			color: #FFFFFF;
			align-items: center;

			.content_pic {
				display: inline-block;
				width: 80px;
				height: 80px;
				overflow: hidden;
			}
		}

		.ordersn-box {
			font-size: 12px;

		}

		.tooldesc {
			width: 100%;
			text-overflow: ellipsis;
			cursor: pointer;
		}


		.el-icon-edit {
			font-size: 14px;
			color: #409EFF;
			cursor: pointer;
		}


		.pic_wrapper {
			display: inline-block;
			width: 50px;
			height: 50px;
			overflow: hidden;
			position: relative;
			border: 1px solid #eee;
			margin: 0.5px;
		}

		.pic-wrapper-desc {
			position: absolute;
			width: 100%;
			left: 0;
			bottom: 0;
			line-height: 12px;
			font-size: 8px;
			font-weight: bold;
			background-color: #67C23A;
			color: #fff;
			text-align: center;
		}

		.pic-wrapper-sensitive {
			position: absolute;
			width: 100%;
			left: 0;
			bottom: 0;
			line-height: 12px;
			font-size: 8px;
			font-weight: bold;
			background-color: #f48c18;
			color: #fff;
			text-align: center;
		}

		.pic-wrapper-quantity {
			position: absolute;
			top: 0;
			right: 0;
			display: inline-block;
			min-width: 15px;
			min-height: 15px;
			line-height: 15px;
			background-color: red;
			font-size: 8px;
			color: #fff;
			text-align: center;
		}


	}
}
.downloadTips {
	// position: fixed;
	// z-index: 999;
	// background: rgba(0, 0, 0, .3);
	// width: 100vw;
	// height: 100vh;
	// top:0;
	// left: 0;
	// display: flex;
	// justify-content: center;
	// align-items: center;
	// color: #fff;
	position: fixed;
	z-index: 999;
	background: rgba(0, 0, 0, .3);
	// width: 100vw;
	// height: 100vh;
	top:50px;
	right: 0;
	width: 100px;
	padding: 10px 20px;
	// height: 200px;
	background-color: #f0f0f0;
	box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.5); /* 阴影效果 */
	display: flex;
	justify-content: center;
	align-items: center;
	// color: #fff;
	box-shadow: #000;
	border-radius: 5px;
	}
.downloadBox {
	position: fixed;
	background: #fff;
	left: 0%;
	top: 0%;
	z-index: 999;
	padding: 10px;
	min-width: 600px;
	// overflow-y: auto;
	// height: 100vh;
	z-index: -2;
	.downloadTop {
		width: 100%;
		height: 50px;
		margin-bottom:10px;
		display: flex;
		align-items: center;
		img {
			width: 50px;
			height: 50px;
			margin-left: 5px;
			margin-right: 5px;
		}
	}
	.downloadContent {
		width: 500px;
		margin: 0 auto;
		// height: 500px;
		img {
			width: 100%;
		}
	}
}
.downloadBoxT {
	z-index: -1;
	width: 100%;
	height: 100%;
}
#canvasImg {
	position: fixed;
	left: 100%;
	top: 0%;
}
</style>
